//#region node_modules/.pnpm/preact@10.29.1/node_modules/preact/dist/preact.module.js
var e, t, n, r, i, a, o, s, c, l, u, d, f, p, m = {}, h = [], g = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, _ = Array.isArray;
function v(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function y(e) {
	e && e.parentNode && e.parentNode.removeChild(e);
}
function b(t, n, r) {
	var i, a, o, s = {};
	for (o in n) o == "key" ? i = n[o] : o == "ref" ? a = n[o] : s[o] = n[o];
	if (arguments.length > 2 && (s.children = arguments.length > 3 ? e.call(arguments, 2) : r), typeof t == "function" && t.defaultProps != null) for (o in t.defaultProps) s[o] === void 0 && (s[o] = t.defaultProps[o]);
	return x(t, s, i, a, null);
}
function x(e, r, i, a, o) {
	var s = {
		type: e,
		props: r,
		key: i,
		ref: a,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: o ?? ++n,
		__i: -1,
		__u: 0
	};
	return o == null && t.vnode != null && t.vnode(s), s;
}
function S(e) {
	return e.children;
}
function C(e, t) {
	this.props = e, this.context = t;
}
function w(e, t) {
	if (t == null) return e.__ ? w(e.__, e.__i + 1) : null;
	for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
	return typeof e.type == "function" ? w(e) : null;
}
function T(e) {
	if (e.__P && e.__d) {
		var n = e.__v, r = n.__e, i = [], a = [], o = v({}, n);
		o.__v = n.__v + 1, t.vnode && t.vnode(o), F(e.__P, o, n, e.__n, e.__P.namespaceURI, 32 & n.__u ? [r] : null, i, r ?? w(n), !!(32 & n.__u), a), o.__v = n.__v, o.__.__k[o.__i] = o, L(i, o, a), n.__e = n.__ = null, o.__e != r && E(o);
	}
}
function E(e) {
	if ((e = e.__) != null && e.__c != null) return e.__e = e.__c.base = null, e.__k.some(function(t) {
		if (t != null && t.__e != null) return e.__e = e.__c.base = t.__e;
	}), E(e);
}
function D(e) {
	(!e.__d && (e.__d = !0) && r.push(e) && !O.__r++ || i != t.debounceRendering) && ((i = t.debounceRendering) || a)(O);
}
function O() {
	try {
		for (var e, t = 1; r.length;) r.length > t && r.sort(o), e = r.shift(), t = r.length, T(e);
	} finally {
		r.length = O.__r = 0;
	}
}
function ee(e, t, n, r, i, a, o, s, c, l, u) {
	var d, f, p, g, _, v, y, b = r && r.__k || h, x = t.length;
	for (c = k(n, t, b, c, x), d = 0; d < x; d++) (p = n.__k[d]) != null && (f = p.__i != -1 && b[p.__i] || m, p.__i = d, v = F(e, p, f, i, a, o, s, c, l, u), g = p.__e, p.ref && f.ref != p.ref && (f.ref && R(f.ref, null, p), u.push(p.ref, p.__c || g, p)), _ == null && g != null && (_ = g), (y = !!(4 & p.__u)) || f.__k === p.__k ? (c = A(p, c, e, y), y && f.__e && (f.__e = null)) : typeof p.type == "function" && v !== void 0 ? c = v : g && (c = g.nextSibling), p.__u &= -7);
	return n.__e = _, c;
}
function k(e, t, n, r, i) {
	var a, o, s, c, l, u = n.length, d = u, f = 0;
	for (e.__k = Array(i), a = 0; a < i; a++) (o = t[a]) != null && typeof o != "boolean" && typeof o != "function" ? (typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? o = e.__k[a] = x(null, o, null, null, null) : _(o) ? o = e.__k[a] = x(S, { children: o }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? o = e.__k[a] = x(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : e.__k[a] = o, c = a + f, o.__ = e, o.__b = e.__b + 1, s = null, (l = o.__i = j(o, n, c, d)) != -1 && (d--, (s = n[l]) && (s.__u |= 2)), s == null || s.__v == null ? (l == -1 && (i > u ? f-- : i < u && f++), typeof o.type != "function" && (o.__u |= 4)) : l != c && (l == c - 1 ? f-- : l == c + 1 ? f++ : (l > c ? f-- : f++, o.__u |= 4))) : e.__k[a] = null;
	if (d) for (a = 0; a < u; a++) (s = n[a]) != null && !(2 & s.__u) && (s.__e == r && (r = w(s)), z(s, s));
	return r;
}
function A(e, t, n, r) {
	var i, a;
	if (typeof e.type == "function") {
		for (i = e.__k, a = 0; i && a < i.length; a++) i[a] && (i[a].__ = e, t = A(i[a], t, n, r));
		return t;
	}
	e.__e != t && (r && (t && e.type && !t.parentNode && (t = w(e)), n.insertBefore(e.__e, t || null)), t = e.__e);
	do
		t = t && t.nextSibling;
	while (t != null && t.nodeType == 8);
	return t;
}
function j(e, t, n, r) {
	var i, a, o, s = e.key, c = e.type, l = t[n], u = l != null && (2 & l.__u) == 0;
	if (l === null && s == null || u && s == l.key && c == l.type) return n;
	if (r > +!!u) {
		for (i = n - 1, a = n + 1; i >= 0 || a < t.length;) if ((l = t[o = i >= 0 ? i-- : a++]) != null && !(2 & l.__u) && s == l.key && c == l.type) return o;
	}
	return -1;
}
function M(e, t, n) {
	t[0] == "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || g.test(t) ? n : n + "px";
}
function N(e, t, n, r, i) {
	var a, o;
	n: if (t == "style") if (typeof n == "string") e.style.cssText = n;
	else {
		if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || M(e.style, t, "");
		if (n) for (t in n) r && n[t] == r[t] || M(e.style, t, n[t]);
	}
	else if (t[0] == "o" && t[1] == "n") a = t != (t = t.replace(u, "$1")), o = t.toLowerCase(), t = o in e || t == "onFocusOut" || t == "onFocusIn" ? o.slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + a] = n, n ? r ? n[l] = r[l] : (n[l] = d, e.addEventListener(t, a ? p : f, a)) : e.removeEventListener(t, a ? p : f, a);
	else {
		if (i == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
		else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
			e[t] = n ?? "";
			break n;
		} catch {}
		typeof n == "function" || (n == null || !1 === n && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
	}
}
function P(e) {
	return function(n) {
		if (this.l) {
			var r = this.l[n.type + e];
			if (n[c] == null) n[c] = d++;
			else if (n[c] < r[l]) return;
			return r(t.event ? t.event(n) : n);
		}
	};
}
function F(e, n, r, i, a, o, s, c, l, u) {
	var d, f, p, m, g, b, x, w, T, E, D, O, k, A, j, M = n.type;
	if (n.constructor !== void 0) return null;
	128 & r.__u && (l = !!(32 & r.__u), o = [c = n.__e = r.__e]), (d = t.__b) && d(n);
	n: if (typeof M == "function") try {
		if (w = n.props, T = M.prototype && M.prototype.render, E = (d = M.contextType) && i[d.__c], D = d ? E ? E.props.value : d.__ : i, r.__c ? x = (f = n.__c = r.__c).__ = f.__E : (T ? n.__c = f = new M(w, D) : (n.__c = f = new C(w, D), f.constructor = M, f.render = B), E && E.sub(f), f.state || (f.state = {}), f.__n = i, p = f.__d = !0, f.__h = [], f._sb = []), T && f.__s == null && (f.__s = f.state), T && M.getDerivedStateFromProps != null && (f.__s == f.state && (f.__s = v({}, f.__s)), v(f.__s, M.getDerivedStateFromProps(w, f.__s))), m = f.props, g = f.state, f.__v = n, p) T && M.getDerivedStateFromProps == null && f.componentWillMount != null && f.componentWillMount(), T && f.componentDidMount != null && f.__h.push(f.componentDidMount);
		else {
			if (T && M.getDerivedStateFromProps == null && w !== m && f.componentWillReceiveProps != null && f.componentWillReceiveProps(w, D), n.__v == r.__v || !f.__e && f.shouldComponentUpdate != null && !1 === f.shouldComponentUpdate(w, f.__s, D)) {
				n.__v != r.__v && (f.props = w, f.state = f.__s, f.__d = !1), n.__e = r.__e, n.__k = r.__k, n.__k.some(function(e) {
					e && (e.__ = n);
				}), h.push.apply(f.__h, f._sb), f._sb = [], f.__h.length && s.push(f);
				break n;
			}
			f.componentWillUpdate != null && f.componentWillUpdate(w, f.__s, D), T && f.componentDidUpdate != null && f.__h.push(function() {
				f.componentDidUpdate(m, g, b);
			});
		}
		if (f.context = D, f.props = w, f.__P = e, f.__e = !1, O = t.__r, k = 0, T) f.state = f.__s, f.__d = !1, O && O(n), d = f.render(f.props, f.state, f.context), h.push.apply(f.__h, f._sb), f._sb = [];
		else do
			f.__d = !1, O && O(n), d = f.render(f.props, f.state, f.context), f.state = f.__s;
		while (f.__d && ++k < 25);
		f.state = f.__s, f.getChildContext != null && (i = v(v({}, i), f.getChildContext())), T && !p && f.getSnapshotBeforeUpdate != null && (b = f.getSnapshotBeforeUpdate(m, g)), A = d != null && d.type === S && d.key == null ? te(d.props.children) : d, c = ee(e, _(A) ? A : [A], n, r, i, a, o, s, c, l, u), f.base = n.__e, n.__u &= -161, f.__h.length && s.push(f), x && (f.__E = f.__ = null);
	} catch (e) {
		if (n.__v = null, l || o != null) if (e.then) {
			for (n.__u |= l ? 160 : 128; c && c.nodeType == 8 && c.nextSibling;) c = c.nextSibling;
			o[o.indexOf(c)] = null, n.__e = c;
		} else {
			for (j = o.length; j--;) y(o[j]);
			I(n);
		}
		else n.__e = r.__e, n.__k = r.__k, e.then || I(n);
		t.__e(e, n, r);
	}
	else o == null && n.__v == r.__v ? (n.__k = r.__k, n.__e = r.__e) : c = n.__e = ne(r.__e, n, r, i, a, o, s, l, u);
	return (d = t.diffed) && d(n), 128 & n.__u ? void 0 : c;
}
function I(e) {
	e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(I));
}
function L(e, n, r) {
	for (var i = 0; i < r.length; i++) R(r[i], r[++i], r[++i]);
	t.__c && t.__c(n, e), e.some(function(n) {
		try {
			e = n.__h, n.__h = [], e.some(function(e) {
				e.call(n);
			});
		} catch (e) {
			t.__e(e, n.__v);
		}
	});
}
function te(e) {
	return typeof e != "object" || !e || e.__b > 0 ? e : _(e) ? e.map(te) : v({}, e);
}
function ne(n, r, i, a, o, s, c, l, u) {
	var d, f, p, h, g, v, b, x = i.props || m, S = r.props, C = r.type;
	if (C == "svg" ? o = "http://www.w3.org/2000/svg" : C == "math" ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), s != null) {
		for (d = 0; d < s.length; d++) if ((g = s[d]) && "setAttribute" in g == !!C && (C ? g.localName == C : g.nodeType == 3)) {
			n = g, s[d] = null;
			break;
		}
	}
	if (n == null) {
		if (C == null) return document.createTextNode(S);
		n = document.createElementNS(o, C, S.is && S), l && (t.__m && t.__m(r, s), l = !1), s = null;
	}
	if (C == null) x === S || l && n.data == S || (n.data = S);
	else {
		if (s = s && e.call(n.childNodes), !l && s != null) for (x = {}, d = 0; d < n.attributes.length; d++) x[(g = n.attributes[d]).name] = g.value;
		for (d in x) g = x[d], d == "dangerouslySetInnerHTML" ? p = g : d == "children" || d in S || d == "value" && "defaultValue" in S || d == "checked" && "defaultChecked" in S || N(n, d, null, g, o);
		for (d in S) g = S[d], d == "children" ? h = g : d == "dangerouslySetInnerHTML" ? f = g : d == "value" ? v = g : d == "checked" ? b = g : l && typeof g != "function" || x[d] === g || N(n, d, g, x[d], o);
		if (f) l || p && (f.__html == p.__html || f.__html == n.innerHTML) || (n.innerHTML = f.__html), r.__k = [];
		else if (p && (n.innerHTML = ""), ee(r.type == "template" ? n.content : n, _(h) ? h : [h], r, i, a, C == "foreignObject" ? "http://www.w3.org/1999/xhtml" : o, s, c, s ? s[0] : i.__k && w(i, 0), l, u), s != null) for (d = s.length; d--;) y(s[d]);
		l || (d = "value", C == "progress" && v == null ? n.removeAttribute("value") : v != null && (v !== n[d] || C == "progress" && !v || C == "option" && v != x[d]) && N(n, d, v, x[d], o), d = "checked", b != null && b != n[d] && N(n, d, b, x[d], o));
	}
	return n;
}
function R(e, n, r) {
	try {
		if (typeof e == "function") {
			var i = typeof e.__u == "function";
			i && e.__u(), i && n == null || (e.__u = e(n));
		} else e.current = n;
	} catch (e) {
		t.__e(e, r);
	}
}
function z(e, n, r) {
	var i, a;
	if (t.unmount && t.unmount(e), (i = e.ref) && (i.current && i.current != e.__e || R(i, null, n)), (i = e.__c) != null) {
		if (i.componentWillUnmount) try {
			i.componentWillUnmount();
		} catch (e) {
			t.__e(e, n);
		}
		i.base = i.__P = null;
	}
	if (i = e.__k) for (a = 0; a < i.length; a++) i[a] && z(i[a], n, r || typeof e.type != "function");
	r || y(e.__e), e.__c = e.__ = e.__e = void 0;
}
function B(e, t, n) {
	return this.constructor(e, n);
}
function V(n, r, i) {
	var a, o, s, c;
	r == document && (r = document.documentElement), t.__ && t.__(n, r), o = (a = typeof i == "function") ? null : i && i.__k || r.__k, s = [], c = [], F(r, n = (!a && i || r).__k = b(S, null, [n]), o || m, m, r.namespaceURI, !a && i ? [i] : o ? null : r.firstChild ? e.call(r.childNodes) : null, s, !a && i ? i : o ? o.__e : r.firstChild, a, c), L(s, n, c);
}
e = h.slice, t = { __e: function(e, t, n, r) {
	for (var i, a, o; t = t.__;) if ((i = t.__c) && !i.__) try {
		if ((a = i.constructor) && a.getDerivedStateFromError != null && (i.setState(a.getDerivedStateFromError(e)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), o = i.__d), o) return i.__E = i;
	} catch (t) {
		e = t;
	}
	throw e;
} }, n = 0, C.prototype.setState = function(e, t) {
	var n = this.__s != null && this.__s != this.state ? this.__s : this.__s = v({}, this.state);
	typeof e == "function" && (e = e(v({}, n), this.props)), e && v(n, e), e != null && this.__v && (t && this._sb.push(t), D(this));
}, C.prototype.forceUpdate = function(e) {
	this.__v && (this.__e = !0, e && this.__h.push(e), D(this));
}, C.prototype.render = S, r = [], a = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, o = function(e, t) {
	return e.__v.__b - t.__v.__b;
}, O.__r = 0, s = Math.random().toString(8), c = "__d" + s, l = "__a" + s, u = /(PointerCapture)$|Capture$/i, d = 0, f = P(!1), p = P(!0);
//#endregion
//#region node_modules/.pnpm/preact@10.29.1/node_modules/preact/hooks/dist/hooks.module.js
var H, U, re, ie, W = 0, ae = [], G = t, oe = G.__b, K = G.__r, q = G.diffed, se = G.__c, ce = G.unmount, le = G.__;
function ue(e, t) {
	G.__h && G.__h(U, e, W || t), W = 0;
	var n = U.__H || (U.__H = {
		__: [],
		__h: []
	});
	return e >= n.__.length && n.__.push({}), n.__[e];
}
function J(e) {
	return W = 1, de(xe, e);
}
function de(e, t, n) {
	var r = ue(H++, 2);
	if (r.t = e, !r.__c && (r.__ = [n ? n(t) : xe(void 0, t), function(e) {
		var t = r.__N ? r.__N[0] : r.__[0], n = r.t(t, e);
		t !== n && (r.__N = [n, r.__[1]], r.__c.setState({}));
	}], r.__c = U, !U.__f)) {
		var i = function(e, t, n) {
			if (!r.__c.__H) return !0;
			var i = r.__c.__H.__.filter(function(e) {
				return e.__c;
			});
			if (i.every(function(e) {
				return !e.__N;
			})) return !a || a.call(this, e, t, n);
			var o = r.__c.props !== e;
			return i.some(function(e) {
				if (e.__N) {
					var t = e.__[0];
					e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0);
				}
			}), a && a.call(this, e, t, n) || o;
		};
		U.__f = !0;
		var a = U.shouldComponentUpdate, o = U.componentWillUpdate;
		U.componentWillUpdate = function(e, t, n) {
			if (this.__e) {
				var r = a;
				a = void 0, i(e, t, n), a = r;
			}
			o && o.call(this, e, t, n);
		}, U.shouldComponentUpdate = i;
	}
	return r.__N || r.__;
}
function Y(e, t) {
	var n = ue(H++, 3);
	!G.__s && be(n.__H, t) && (n.__ = e, n.u = t, U.__H.__h.push(n));
}
function fe(e, t) {
	var n = ue(H++, 4);
	!G.__s && be(n.__H, t) && (n.__ = e, n.u = t, U.__h.push(n));
}
function X(e) {
	return W = 5, pe(function() {
		return { current: e };
	}, []);
}
function pe(e, t) {
	var n = ue(H++, 7);
	return be(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
}
function me(e, t) {
	return W = 8, pe(function() {
		return e;
	}, t);
}
function he() {
	for (var e; e = ae.shift();) {
		var t = e.__H;
		if (e.__P && t) try {
			t.__h.some(ve), t.__h.some(ye), t.__h = [];
		} catch (n) {
			t.__h = [], G.__e(n, e.__v);
		}
	}
}
G.__b = function(e) {
	U = null, oe && oe(e);
}, G.__ = function(e, t) {
	e && t.__k && t.__k.__m && (e.__m = t.__k.__m), le && le(e, t);
}, G.__r = function(e) {
	K && K(e), H = 0;
	var t = (U = e.__c).__H;
	t && (re === U ? (t.__h = [], U.__h = [], t.__.some(function(e) {
		e.__N && (e.__ = e.__N), e.u = e.__N = void 0;
	})) : (t.__h.some(ve), t.__h.some(ye), t.__h = [], H = 0)), re = U;
}, G.diffed = function(e) {
	q && q(e);
	var t = e.__c;
	t && t.__H && (t.__H.__h.length && (ae.push(t) !== 1 && ie === G.requestAnimationFrame || ((ie = G.requestAnimationFrame) || _e)(he)), t.__H.__.some(function(e) {
		e.u && (e.__H = e.u), e.u = void 0;
	})), re = U = null;
}, G.__c = function(e, t) {
	t.some(function(e) {
		try {
			e.__h.some(ve), e.__h = e.__h.filter(function(e) {
				return !e.__ || ye(e);
			});
		} catch (n) {
			t.some(function(e) {
				e.__h && (e.__h = []);
			}), t = [], G.__e(n, e.__v);
		}
	}), se && se(e, t);
}, G.unmount = function(e) {
	ce && ce(e);
	var t, n = e.__c;
	n && n.__H && (n.__H.__.some(function(e) {
		try {
			ve(e);
		} catch (e) {
			t = e;
		}
	}), n.__H = void 0, t && G.__e(t, n.__v));
};
var ge = typeof requestAnimationFrame == "function";
function _e(e) {
	var t, n = function() {
		clearTimeout(r), ge && cancelAnimationFrame(t), setTimeout(e);
	}, r = setTimeout(n, 35);
	ge && (t = requestAnimationFrame(n));
}
function ve(e) {
	var t = U, n = e.__c;
	typeof n == "function" && (e.__c = void 0, n()), U = t;
}
function ye(e) {
	var t = U;
	e.__c = e.__(), U = t;
}
function be(e, t) {
	return !e || e.length !== t.length || t.some(function(t, n) {
		return t !== e[n];
	});
}
function xe(e, t) {
	return typeof t == "function" ? t(e) : t;
}
//#endregion
//#region node_modules/.pnpm/preact@10.29.1/node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
var Se = 0;
Array.isArray;
function Z(e, n, r, i, a, o) {
	n || (n = {});
	var s, c, l = n;
	if ("ref" in l) for (c in l = {}, n) c == "ref" ? s = n[c] : l[c] = n[c];
	var u = {
		type: e,
		props: l,
		key: r,
		ref: s,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: --Se,
		__i: -1,
		__u: 0,
		__source: a,
		__self: o
	};
	if (typeof e == "function" && (s = e.defaultProps)) for (c in s) l[c] === void 0 && (l[c] = s[c]);
	return t.vnode && t.vnode(u), u;
}
//#endregion
//#region src/product-switcher/components/VariantSelector.tsx
function Ce({ product: e, onChange: t }) {
	if (!e.options.length || !e.variants.length) return null;
	let n = e.variants.find((t) => t.id === e.variantId);
	return /* @__PURE__ */ Z("div", {
		class: "ps-variant-selector",
		"data-ps-variant-selector": !0,
		children: e.options.map((r, i) => /* @__PURE__ */ Z("fieldset", {
			class: "ps-variant-selector__group",
			children: [/* @__PURE__ */ Z("legend", {
				class: "ps-variant-selector__label",
				children: r.name
			}), /* @__PURE__ */ Z("div", {
				class: "ps-variant-selector__options",
				children: r.values.map((r) => /* @__PURE__ */ Z("button", {
					type: "button",
					class: "ps-variant-selector__option",
					"aria-pressed": n?.options[i] === r,
					disabled: !e.variants.some((e) => e.available && e.options[i] === r),
					onClick: () => t(i, r),
					children: r
				}, r))
			})]
		}, r.name))
	});
}
//#endregion
//#region src/product-switcher/components/blocks/BuyRow.tsx
var we = {
	accent: "var(--accent)",
	"accent-fg": "var(--accent-fg)",
	theme: "var(--color-foreground)"
}, Te = [
	{
		qty: 1,
		savings: null,
		badge: null
	},
	{
		qty: 2,
		savings: "Save 10%",
		badge: null
	},
	{
		qty: 3,
		savings: "Save 15%",
		badge: "Best Value"
	}
], Ee = 30, De = "1", Oe = "TBSP";
function ke(e) {
	let t = Number(e.servingsPerCan);
	return Number.isFinite(t) && t > 0 ? t : Ee;
}
function Ae(e) {
	switch (e.servingUnit?.trim().toUpperCase()) {
		case "TBSP": return "TBSP";
		case "TSP": return "TSP";
		default: return Oe;
	}
}
function je(e) {
	let t = Number(e.servingSize);
	return Number.isFinite(t) && t > 0 ? Number.parseFloat(t.toFixed(2)).toString() : De;
}
function Me(e) {
	return `${je(e)}${Ae(e)}`;
}
function Ne({ value: e, min: t, max: n, servingsPerCan: r, servingLabel: i, onChange: a }) {
	return /* @__PURE__ */ Z("div", {
		class: "ps-can-selector",
		children: [/* @__PURE__ */ Z("span", {
			class: "ps-can-selector__label",
			children: "Bundle & Save"
		}), /* @__PURE__ */ Z("div", {
			class: "ps-can-selector__options",
			children: Te.map((o) => {
				let s = o.qty < t || o.qty > n;
				return /* @__PURE__ */ Z("button", {
					type: "button",
					class: "ps-can-selector__option",
					"aria-pressed": e === o.qty,
					disabled: s,
					onClick: () => a(o.qty),
					children: [
						o.badge ? /* @__PURE__ */ Z("span", {
							class: "ps-can-selector__badge",
							children: o.badge
						}) : null,
						/* @__PURE__ */ Z("span", {
							class: "ps-can-selector__amount",
							children: [
								o.qty,
								" ",
								o.qty === 1 ? "Can" : "Cans"
							]
						}),
						/* @__PURE__ */ Z("span", {
							class: "ps-can-selector__meta",
							children: [
								o.qty * r,
								" ",
								i,
								" Servings",
								o.savings ? /* @__PURE__ */ Z(S, { children: [/* @__PURE__ */ Z("span", {
									"aria-hidden": "true",
									children: " · "
								}), /* @__PURE__ */ Z("span", { children: o.savings })] }) : null
							]
						})
					]
				}, o.qty);
			})
		})]
	});
}
function Pe({ product: e, buttonBg: t, klaviyoCompanyId: n }) {
	let r = t === we.accent ? void 0 : { "--accent": t };
	return /* @__PURE__ */ Z("div", {
		class: "ps-buyzone__cart-row",
		children: /* @__PURE__ */ Z("back-in-stock", {
			product_title: e.title,
			variant_title: e.variantTitle,
			variant_id: String(e.variantId),
			company_id: n,
			style: r
		})
	});
}
function Fe({ block: e, product: t, qty: n, onQty: r, onOption: i, planId: a, pending: o, error: s, onSubmit: c, klaviyoCompanyId: l, addingToCartLabel: u = "Adding…", bundleEligible: d }) {
	let { atc_label: f, qty_min: p, qty_max: m, color_source: h } = e.settings, g = we[h] || we.accent, _ = ke(t), v = Me(t);
	return t.available ? /* @__PURE__ */ Z("form", {
		class: "ps-buyzone__form",
		"data-ps-form": !0,
		novalidate: !0,
		onSubmit: c,
		children: [
			/* @__PURE__ */ Z("input", {
				type: "hidden",
				name: "id",
				value: t.variantId
			}),
			/* @__PURE__ */ Z("input", {
				type: "hidden",
				name: "quantity",
				value: d ? n : 1
			}),
			a !== null && /* @__PURE__ */ Z("input", {
				type: "hidden",
				name: "selling_plan",
				value: a
			}),
			/* @__PURE__ */ Z(Ce, {
				product: t,
				onChange: i
			}),
			d ? /* @__PURE__ */ Z(Ne, {
				value: n,
				min: p,
				max: m,
				servingsPerCan: _,
				servingLabel: v,
				onChange: r
			}) : null,
			/* @__PURE__ */ Z("div", {
				class: "ps-buyzone__cart-row",
				children: /* @__PURE__ */ Z("button", {
					type: "submit",
					class: "ps-atc",
					"data-ps-atc": !0,
					style: { background: g },
					disabled: o,
					children: o ? u : f
				})
			}),
			s && /* @__PURE__ */ Z("p", {
				class: "ps-buyzone__error",
				role: "alert",
				children: s
			})
		]
	}) : /* @__PURE__ */ Z("div", {
		class: "ps-buyzone__form",
		children: [/* @__PURE__ */ Z(Ce, {
			product: t,
			onChange: i
		}), /* @__PURE__ */ Z(Pe, {
			product: t,
			buttonBg: g,
			klaviyoCompanyId: l
		})]
	});
}
//#endregion
//#region src/product-switcher/components/blocks/Description.tsx
function Ie(e) {
	return e.toLowerCase().replace(/\s+/g, " ").trim();
}
function Le(e) {
	let t = e.previousElementSibling;
	for (; t && Ie(t.textContent || "") === "";) {
		let e = t;
		t = t.previousElementSibling, e.remove();
	}
	t && /^ingredients:?$/i.test(Ie(t.textContent || "")) && t.remove();
}
function Re(e, t) {
	if (!e || !t.length || typeof document > "u") return e;
	let n = t.map((e) => Ie(e.name)).filter(Boolean);
	if (!n.length) return e;
	let r = document.createElement("div");
	return r.innerHTML = e, r.querySelectorAll("ul").forEach((e) => {
		let t = Ie(e.textContent || "");
		n.filter((e) => t.includes(e)).length >= Math.min(2, n.length) && (Le(e), e.remove());
	}), r.innerHTML;
}
function ze({ html: e, ingredients: t }) {
	return /* @__PURE__ */ Z("div", {
		class: "ps-buyzone__description rte",
		"data-ps-description": !0,
		dangerouslySetInnerHTML: { __html: Re(e, t) }
	});
}
//#endregion
//#region src/product-switcher/components/blocks/Ingredients.tsx
function Be() {
	return /* @__PURE__ */ Z("span", {
		class: "ps-ingredients__icon",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ Z("svg", {
			class: "ps-ingredients__icon-svg ps-ingredients__icon-svg--plus",
			viewBox: "0 0 20 20",
			fill: "none",
			focusable: "false",
			children: [/* @__PURE__ */ Z("title", { children: "Expand ingredient" }), /* @__PURE__ */ Z("path", {
				d: "M10 5v10M5 10h10",
				stroke: "currentColor",
				strokeWidth: "2.25",
				strokeLinecap: "square"
			})]
		}), /* @__PURE__ */ Z("svg", {
			class: "ps-ingredients__icon-svg ps-ingredients__icon-svg--x",
			viewBox: "0 0 20 20",
			fill: "none",
			focusable: "false",
			children: [/* @__PURE__ */ Z("title", { children: "Collapse ingredient" }), /* @__PURE__ */ Z("path", {
				d: "M6 6l8 8M14 6l-8 8",
				stroke: "currentColor",
				strokeWidth: "2.25",
				strokeLinecap: "square"
			})]
		})]
	});
}
function Ve({ block: e, nutritionFactsImage: t, ingredients: n }) {
	return !n.length && !t ? null : /* @__PURE__ */ Z("section", {
		class: "ps-ingredients",
		"data-ps-ingredients": !0,
		children: /* @__PURE__ */ Z("div", {
			class: "ps-ingredients__content",
			children: [t ? /* @__PURE__ */ Z("div", {
				class: "ps-ingredients__media",
				children: /* @__PURE__ */ Z("img", {
					class: "ps-ingredients__image",
					src: t.src,
					alt: t.alt,
					width: t.width,
					height: t.height,
					loading: "lazy"
				})
			}) : null, n.length ? /* @__PURE__ */ Z("div", {
				class: "ps-ingredients__details",
				children: [e.settings.heading ? /* @__PURE__ */ Z("h2", {
					class: "ps-ingredients__heading",
					children: e.settings.heading
				}) : null, n.map((e) => /* @__PURE__ */ Z("details", {
					class: "ps-ingredients__row",
					children: [/* @__PURE__ */ Z("summary", {
						class: "ps-ingredients__summary",
						children: [/* @__PURE__ */ Z("span", { children: e.name }), /* @__PURE__ */ Z(Be, {})]
					}), e.descriptionHtml ? /* @__PURE__ */ Z("div", {
						class: "ps-ingredients__description rte",
						dangerouslySetInnerHTML: { __html: e.descriptionHtml }
					}) : null]
				}, e.name))]
			}) : null]
		})
	});
}
//#endregion
//#region src/product-switcher/components/blocks/MadeInUsa.tsx
function He({ block: e }) {
	return /* @__PURE__ */ Z("p", {
		class: "ps-made-in-usa",
		children: [/* @__PURE__ */ Z("img", {
			class: "ps-made-in-usa__flag",
			src: e.settings.flag_url,
			alt: "",
			width: "100",
			height: "55",
			loading: "lazy"
		}), /* @__PURE__ */ Z("span", { children: "Made in the USA" })]
	});
}
//#endregion
//#region src/product-switcher/hooks/useOkendo.ts
var Ue = 200, We = 8e3;
function Ge(e) {
	let t = !1, n = 0, r = Date.now(), i = () => {
		if (!t) {
			if (typeof window.okeWidgetApi?.initWidget == "function" && typeof window.okeWidgetApi?.setProduct == "function") {
				e();
				return;
			}
			Date.now() - r >= We || (n = window.setTimeout(i, Ue));
		}
	};
	return i(), () => {
		t = !0, n && window.clearTimeout(n);
	};
}
function Ke(e, t) {
	Y(() => Ge(() => {
		let n = t.current, r = window.okeWidgetApi;
		if (!(!n || !r)) try {
			r.setProduct?.(n, `shopify-${e}`), r.initWidget?.(n, !0);
		} catch (e) {
			console.warn("[product-switcher] okendo init failed", e);
		}
	}), [e]);
}
//#endregion
//#region src/product-switcher/components/OkendoWidget.tsx
function qe({ productId: e, snippetHtml: t }) {
	let n = X(null);
	return Ke(e, n), /* @__PURE__ */ Z("div", {
		ref: n,
		"data-oke-widget": "",
		"data-oke-reviews-product-id": `shopify-${e}`,
		dangerouslySetInnerHTML: { __html: t }
	}, e);
}
//#endregion
//#region src/product-switcher/components/blocks/OkendoBlock.tsx
function Je({ productId: e, snippetHtml: t }) {
	return /* @__PURE__ */ Z("div", {
		class: "ps-reviews",
		"data-ps-reviews": !0,
		children: /* @__PURE__ */ Z(qe, {
			productId: e,
			snippetHtml: t
		})
	});
}
//#endregion
//#region src/product-switcher/lib/bundlePricing.ts
function Ye(e) {
	return [...e].sort((e, t) => t.minQty - e.minQty);
}
function Xe(e, t) {
	let n = Ye(e);
	for (let e of n) if (e.minQty > 0 && e.pct > 0 && t >= e.minQty) return e;
	return null;
}
function Ze(e, t, n, r, i = 0) {
	let a = Xe(r, n), o = 1 - (a?.pct ?? 0) / 100, s = 1 - i / 100, c = Math.round(e * o * s), l = Math.round((1 - o * s) * 100 * 100) / 100;
	return {
		unitPrice: c,
		originalUnit: e,
		totalPrice: c * t,
		originalTotal: e * t,
		appliedPct: l,
		appliedTier: a
	};
}
//#endregion
//#region src/product-switcher/components/blocks/Price.tsx
var Qe = /* @__PURE__ */ new Map();
function $e(e, t) {
	let n = e % 100 == 0, r = `${t || "USD"}:${n ? "whole" : "fractional"}`, i = Qe.get(r);
	return i || (i = new Intl.NumberFormat(void 0, {
		style: "currency",
		currency: t || "USD",
		...n ? {
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		} : {}
	}), Qe.set(r, i)), i.format(e / 100);
}
function et({ product: e, qty: t = 1, cartCanCount: n = 0, tiers: r = [], subPct: i = 0, showPerUnit: a = !0 }) {
	let o = t + n, s = Ze(e.price, t, o, r, i), c = s.unitPrice < s.originalUnit, l = e.compareAtPrice && e.compareAtPrice > e.price ? e.compareAtPrice : null, u = t > 1 && a;
	return /* @__PURE__ */ Z("div", {
		class: "ps-buyzone__price",
		children: [
			/* @__PURE__ */ Z("span", {
				class: "ps-price",
				children: $e(s.totalPrice, e.currency)
			}),
			c ? /* @__PURE__ */ Z("s", {
				class: "ps-compare-at ps-price__sub",
				children: $e(s.originalTotal, e.currency)
			}) : l && /* @__PURE__ */ Z("s", {
				class: "ps-compare-at",
				children: $e(l * t, e.currency)
			}),
			u && /* @__PURE__ */ Z("span", {
				class: "ps-price__unit",
				children: [$e(s.unitPrice, e.currency), "/can"]
			})
		]
	});
}
//#endregion
//#region src/product-switcher/hooks/useReviewMarqueeRow.ts
var tt = 64e3, nt = 1.8, rt = .02, it = .0045, at = "(prefers-reduced-motion: reduce)";
function ot(e, t) {
	if (t <= 0) return e;
	let n = e % t;
	return n > 0 && (n -= t), n <= -t && (n += t), n;
}
function st(e) {
	return Math.max(-nt, Math.min(nt, e));
}
function ct(e) {
	return Math.abs(e) >= rt ? st(e) : 0;
}
function lt(e, t) {
	return Math.abs(e + t) < .5;
}
function ut({ direction: e, repeatCount: t }) {
	let n = X(null), r = X(null), i = X(!1), a = X(!1), o = X(0), s = X(0), c = X(0), l = X(null), u = X(!1), [d, f] = J(!1), p = (e) => {
		let t = n.current;
		t && (t.style.transform = `translateX(${e}px)`);
	}, m = () => {
		let e = n.current;
		if (!e || s.current > 0) return s.current;
		let r = Number.parseFloat(e.style.getPropertyValue("--review-loop-distance"));
		if (Number.isFinite(r) && r > 0) return s.current = r, r;
		let i = e.scrollWidth / t;
		return i > 0 && (s.current = i), s.current;
	};
	fe(() => {
		let r = n.current;
		if (!r) return;
		let i = () => {
			let n = r.scrollWidth / t;
			if (n <= 0) return;
			let i = e === "right" && lt(c.current, s.current);
			s.current = n, u.current ? i ? c.current = -n : c.current = ot(c.current, n) : (c.current = e === "right" ? -n : 0, u.current = !0), r.style.setProperty("--review-loop-distance", `${n}px`), p(c.current);
		};
		if (i(), typeof ResizeObserver > "u") return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
		let a = new ResizeObserver(i);
		return a.observe(r), () => a.disconnect();
	}, [e, t]), Y(() => {
		if (typeof window.matchMedia != "function") return;
		let e = window.matchMedia(at), t = () => {
			a.current = e.matches, e.matches && (o.current = 0), l.current = null;
		};
		return t(), e.addEventListener?.("change", t), () => e.removeEventListener?.("change", t);
	}, []), Y(() => {
		let t = 0, u = (d) => {
			let f = n.current, p = s.current, m = l.current;
			if (l.current = d, a.current) {
				o.current = 0, t = window.requestAnimationFrame(u);
				return;
			}
			if (f && p > 0 && m !== null && !r.current) {
				let t = d - m, n = i.current ? 0 : p / tt * (e === "right" ? 1 : -1), r = o.current;
				if (c.current = ot(c.current + (n + r) * t, p), Math.abs(r) > 0) {
					let e = r * Math.exp(-it * t);
					o.current = Math.abs(e) < rt ? 0 : e;
				}
				f.style.transform = `translateX(${c.current}px)`;
			}
			t = window.requestAnimationFrame(u);
		};
		return t = window.requestAnimationFrame(u), () => {
			window.cancelAnimationFrame(t), l.current = null;
		};
	}, [e]);
	let h = () => {
		r.current && (c.current = r.current.offset, o.current = a.current ? 0 : ct(r.current.velocity), p(c.current)), r.current = null, f(!1), l.current = null;
	};
	return {
		isDragging: d,
		onLostPointerCapture: h,
		onPointerCancel: h,
		onPointerDown: (e) => {
			if (e.isPrimary === !1 || e.pointerType === "mouse" && e.button !== 0) return;
			let t = m();
			if (t <= 0) return;
			let n = ot(c.current, t);
			o.current = 0, p(n), r.current = {
				pointerId: e.pointerId,
				lastX: e.clientX,
				lastTime: e.timeStamp,
				loopDistance: t,
				offset: n,
				velocity: 0
			}, f(!0), e.currentTarget.setPointerCapture?.(e.pointerId), e.preventDefault();
		},
		onPointerEnter: (e) => {
			let t = typeof window.matchMedia == "function" && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
			e.pointerType !== "mouse" || !t || (i.current = !0);
		},
		onPointerLeave: () => {
			i.current = !1, l.current = null;
		},
		onPointerMove: (e) => {
			let t = r.current;
			if (!t || e.pointerId !== t.pointerId) return;
			let n = e.clientX - t.lastX, i = e.timeStamp, a = Math.max(1, i - t.lastTime);
			t.offset = ot(t.offset + n, t.loopDistance), t.velocity = st(n / a), c.current = t.offset, t.lastX = e.clientX, t.lastTime = i, p(t.offset), e.preventDefault();
		},
		onPointerUp: (e) => {
			let t = r.current;
			if (!(!t || e.pointerId !== t.pointerId)) {
				try {
					e.currentTarget.releasePointerCapture?.(e.pointerId);
				} catch {}
				h();
			}
		},
		trackRef: n
	};
}
//#endregion
//#region src/product-switcher/components/blocks/ReviewMarquee.tsx
var dt = 6;
function ft(e) {
	if (!e) return null;
	let t = new Date(e);
	if (Number.isNaN(t.getTime())) return null;
	let n = t.getUTCFullYear(), r = String(t.getUTCMonth() + 1).padStart(2, "0"), i = String(t.getUTCDate()).padStart(2, "0");
	return {
		display: `${r}/${i}/${n}`,
		machine: `${n}-${r}-${i}`
	};
}
function pt(e, t, n) {
	let r = String(e.body || "").trim();
	if (!r) return null;
	let i = Math.max(0, Math.min(5, Math.round(Number(e.rating) || 5))), a = String(e.reviewer?.displayName || e.reviewer?.name || e.customer?.displayName || e.customer?.name || e.reviewerName || e.displayName || "Verified customer").trim();
	return {
		id: e.reviewId || e.id || `review-${t}`,
		body: r,
		title: String(e.title || "").trim(),
		rating: i,
		reviewerName: a,
		isVerified: !!(e.reviewer?.isVerified || e.isVerified || e.verifiedBuyer),
		date: ft(e.dateCreated),
		image: n
	};
}
function mt(e) {
	return e.reduce((e, t, n) => (e[n % 2].push(t), e), [[], []]);
}
function ht({ card: e }) {
	let t = "★".repeat(e.rating) + "☆".repeat(5 - e.rating);
	return /* @__PURE__ */ Z("article", {
		class: "ps-review-card",
		children: [/* @__PURE__ */ Z("div", {
			class: "ps-review-card__content",
			children: [
				/* @__PURE__ */ Z("div", {
					class: "ps-review-card__stars",
					role: "img",
					"aria-label": `${e.rating} out of 5 stars`,
					children: t
				}),
				e.title ? /* @__PURE__ */ Z("h3", {
					class: "ps-review-card__title",
					children: e.title
				}) : null,
				/* @__PURE__ */ Z("p", {
					class: "ps-review-card__body",
					children: e.body
				})
			]
		}), /* @__PURE__ */ Z("footer", {
			class: "ps-review-card__footer",
			children: /* @__PURE__ */ Z("div", {
				class: "ps-review-card__byline",
				children: [/* @__PURE__ */ Z("span", {
					class: "ps-review-card__attribution",
					children: [/* @__PURE__ */ Z("span", {
						class: "ps-review-card__author",
						children: e.reviewerName
					}), e.date ? /* @__PURE__ */ Z("time", {
						class: "ps-review-card__date",
						datetime: e.date.machine,
						children: e.date.display
					}) : null]
				}), e.isVerified ? /* @__PURE__ */ Z("span", {
					class: "ps-review-card__verified",
					children: "Verified buyer"
				}) : null]
			})
		})]
	});
}
function gt({ image: e }) {
	return /* @__PURE__ */ Z("figure", {
		class: "ps-review-image-card",
		"aria-label": e.alt,
		children: /* @__PURE__ */ Z("img", {
			class: "ps-review-image-card__image",
			src: e.src,
			alt: e.alt,
			width: e.width,
			height: e.height,
			loading: "lazy"
		})
	});
}
function _t({ cards: e, direction: t }) {
	let n = ut({
		direction: t,
		repeatCount: dt
	});
	if (!e.length) return null;
	let r = Array.from({ length: dt }, () => e).flat();
	return /* @__PURE__ */ Z("div", {
		class: "ps-review-marquee__row",
		"data-direction": t,
		"data-dragging": n.isDragging ? "true" : void 0,
		"data-interactive": "true",
		onPointerDown: n.onPointerDown,
		onPointerEnter: n.onPointerEnter,
		onPointerLeave: n.onPointerLeave,
		onPointerMove: n.onPointerMove,
		onPointerUp: n.onPointerUp,
		onPointerCancel: n.onPointerCancel,
		onLostPointerCapture: n.onLostPointerCapture,
		children: /* @__PURE__ */ Z("div", {
			class: "ps-review-marquee__track",
			ref: n.trackRef,
			children: r.map((e, t) => /* @__PURE__ */ Z(S, { children: [/* @__PURE__ */ Z(ht, { card: e }), e.image ? /* @__PURE__ */ Z(gt, { image: e.image }) : null] }, `${e.id}-${t}`))
		})
	});
}
function vt({ block: e, product: t, okendoStoreId: n }) {
	let [r, i] = J([]), a = X(null), o = Math.max(1, Math.min(25, Number(e.settings.limit) || 10));
	Ke(t.id, a), Y(() => {
		if (!n) {
			i([]);
			return;
		}
		let e = !0, r = new AbortController(), a = t.reviewImages || [], s = new URL(`https://api.okendo.io/v1/stores/${n}/products/shopify-${t.id}/reviews`);
		s.searchParams.set("limit", String(o)), s.searchParams.set("orderBy", "date desc"), i([]);
		async function c() {
			try {
				let t = await fetch(s.toString(), { signal: r.signal });
				if (!t.ok) throw Error(`Okendo reviews request failed: ${t.status}`);
				let n = ((await t.json()).reviews || []).map((e, t) => pt(e, t, a[t])).filter((e) => e !== null);
				if (!e) return;
				i(n);
			} catch (t) {
				if (r.signal.aborted || !e) return;
				console.warn("[product-switcher] review marquee failed to load", t), i([]);
			}
		}
		return c(), () => {
			e = !1, r.abort();
		};
	}, [
		o,
		n,
		t.id,
		t.reviewImages
	]);
	let [s, c] = pe(() => mt(r), [r]);
	return !n || !r.length ? null : r.length < 2 ? /* @__PURE__ */ Z("section", {
		class: "ps-review-marquee ps-review-marquee--static",
		"data-ps-review-marquee": !0,
		children: /* @__PURE__ */ Z(ht, { card: r[0] })
	}) : /* @__PURE__ */ Z("section", {
		class: "ps-review-marquee",
		"data-ps-review-marquee": !0,
		children: [
			/* @__PURE__ */ Z("div", {
				class: "ps-review-marquee__toolbar",
				children: /* @__PURE__ */ Z("div", {
					class: "ps-review-marquee__write",
					ref: a,
					"data-oke-widget": !0,
					"data-oke-reviews-write-review-product-id": `shopify-${t.id}`
				})
			}),
			/* @__PURE__ */ Z(_t, {
				cards: s,
				direction: "right"
			}),
			/* @__PURE__ */ Z(_t, {
				cards: c.length ? c : s,
				direction: "left"
			})
		]
	});
}
//#endregion
//#region src/product-switcher/components/blocks/SugarImage.tsx
function yt(e) {
	return e.split(/\n{2,}/).map((e) => e.trim()).filter(Boolean);
}
function bt(e) {
	return e === e.toUpperCase() && /[A-Z]/.test(e) && !e.startsWith("\"");
}
function xt({ block: e }) {
	let { image: t, heading: n, summary: r, manifesto_title: i, details: a } = e.settings, [o, s] = J(!1), c = yt(a || "");
	return !t && !n && !r && !c.length ? null : /* @__PURE__ */ Z("section", {
		class: `ps-sugar-image${o ? " is-expanded" : ""}`,
		"data-ps-sugar-image": !0,
		children: /* @__PURE__ */ Z("div", {
			class: "ps-sugar-image__content",
			children: [n || r || c.length ? /* @__PURE__ */ Z("div", {
				class: "ps-sugar-image__text",
				children: [n ? /* @__PURE__ */ Z("h2", {
					class: "ps-sugar-image__heading",
					dangerouslySetInnerHTML: { __html: n }
				}) : null, o ? /* @__PURE__ */ Z("div", {
					class: "ps-sugar-image__details",
					children: [
						i ? /* @__PURE__ */ Z("h3", { children: i }) : null,
						c.map((e, t) => bt(e) ? /* @__PURE__ */ Z("h4", { children: e }, `${t}-${e}`) : /* @__PURE__ */ Z("p", { children: e }, `${t}-${e}`)),
						/* @__PURE__ */ Z("button", {
							class: "ps-sugar-image__toggle",
							type: "button",
							"aria-expanded": "true",
							onClick: () => s(!1),
							children: "READ LESS"
						})
					]
				}) : /* @__PURE__ */ Z("div", {
					class: "ps-sugar-image__summary",
					children: [r ? /* @__PURE__ */ Z("p", { children: /* @__PURE__ */ Z("em", { children: r }) }) : null, c.length ? /* @__PURE__ */ Z("button", {
						class: "ps-sugar-image__toggle",
						type: "button",
						"aria-expanded": "false",
						onClick: () => s(!0),
						children: "READ MORE"
					}) : null]
				})]
			}) : null, t ? /* @__PURE__ */ Z("div", {
				class: "ps-sugar-image__media",
				children: /* @__PURE__ */ Z("img", {
					class: "ps-sugar-image__image",
					src: t.src,
					alt: t.alt,
					width: t.width,
					height: t.height,
					loading: "lazy"
				})
			}) : null]
		})
	});
}
//#endregion
//#region src/product-switcher/components/blocks/Text.tsx
var St = {
	black: "rgb(0 0 0)",
	accent: "var(--accent-ink, var(--accent))",
	"accent-fg": "var(--accent-fg)",
	theme: "var(--color-foreground)"
};
function Ct({ block: e }) {
	let { text: t, color_source: n, alignment: r } = e.settings;
	return /* @__PURE__ */ Z("div", {
		class: "ps-bundle-badge",
		style: {
			color: St[n] || St.accent,
			textAlign: r
		},
		children: t
	});
}
//#endregion
//#region src/product-switcher/components/blocks/Title.tsx
var wt = new Set([
	"h1",
	"h2",
	"h3"
]);
function Tt({ block: e, product: t }) {
	let n = e.settings.heading_level && wt.has(e.settings.heading_level) ? e.settings.heading_level : "h1", r = X(null);
	return Y(() => {
		let e = r.current, t = window.fitty;
		if (!e || !t) return;
		let n = t(e, {
			minSize: 16,
			multiLine: !1,
			observeMutations: !1,
			remeasureOnResize: !0
		});
		n.fit();
		let i = e.parentElement, a = typeof ResizeObserver < "u" && i ? new ResizeObserver(() => n.fit()) : null;
		a?.observe(i);
		let o = () => n.fit();
		return window.addEventListener("resize", o), () => {
			a?.disconnect(), window.removeEventListener("resize", o), n.unsubscribe();
		};
	}, [t.title]), Z(n === "h2" ? "h2" : n === "h3" ? "h3" : "h1", {
		ref: r,
		class: "ps-buyzone__title",
		children: t.title
	});
}
//#endregion
//#region src/product-switcher/components/blocks/Usp.tsx
function Et({ usps: e }) {
	if (!e.length) return null;
	let t = Math.ceil(e.length / 2), n = e.slice(0, t), r = e.slice(t);
	return /* @__PURE__ */ Z("div", {
		class: "ps-usp",
		children: [/* @__PURE__ */ Z("ul", {
			class: "ps-usp__col ps-usp__col--left",
			children: n.map((e) => /* @__PURE__ */ Z("li", { children: e }))
		}), r.length > 0 && /* @__PURE__ */ Z("ul", {
			class: "ps-usp__col ps-usp__col--right",
			children: r.map((e) => /* @__PURE__ */ Z("li", { children: e }))
		})]
	});
}
//#endregion
//#region src/product-switcher/components/PlanToggle.tsx
function Dt({ label: e, badge: t }) {
	return /* @__PURE__ */ Z(S, { children: [e, t ? /* @__PURE__ */ Z("span", {
		class: "ps-plan-toggle__badge",
		children: t
	}) : null] });
}
function Ot({ plans: e, activePlanId: t, onChange: n, oneTimeLabel: r = "ONE-TIME", subscribeLabel: i = "SUBSCRIBE & SAVE", subscribeBadge: a }) {
	if (!e.length) return null;
	let o = e[0], s = `ps-plan-toggle-${o.id}`, c = `${s}-label`, l = t === null, u = t === o.id, d = +!l, f = r.toUpperCase(), p = i.toUpperCase();
	return /* @__PURE__ */ Z("div", {
		class: "ps-plan-toggle",
		"data-ps-plan-toggle": !0,
		"data-active-index": d,
		role: "radiogroup",
		"aria-labelledby": c,
		children: [
			/* @__PURE__ */ Z("span", {
				id: c,
				class: "visually-hidden",
				children: "Purchase type"
			}),
			/* @__PURE__ */ Z("div", {
				class: "ps-plan-toggle__layer ps-plan-toggle__layer--inactive",
				children: [/* @__PURE__ */ Z("label", {
					class: "ps-plan-toggle__option",
					"data-ps-plan": "",
					"data-active": l ? "true" : "false",
					children: [/* @__PURE__ */ Z("input", {
						class: "ps-plan-toggle__input",
						type: "radio",
						name: s,
						checked: l,
						onChange: () => n(null)
					}), f]
				}), /* @__PURE__ */ Z("label", {
					class: "ps-plan-toggle__option",
					"data-ps-plan": o.id,
					"data-active": u ? "true" : "false",
					children: [/* @__PURE__ */ Z("input", {
						class: "ps-plan-toggle__input",
						type: "radio",
						name: s,
						checked: u,
						onChange: () => n(o.id)
					}), /* @__PURE__ */ Z(Dt, {
						label: p,
						badge: a
					})]
				})]
			}),
			/* @__PURE__ */ Z("div", {
				class: "ps-plan-toggle__layer ps-plan-toggle__layer--active",
				"aria-hidden": "true",
				children: [/* @__PURE__ */ Z("span", {
					class: "ps-plan-toggle__option",
					"data-ps-plan": "",
					"data-active": l ? "true" : "false",
					children: f
				}), /* @__PURE__ */ Z("span", {
					class: "ps-plan-toggle__option",
					"data-ps-plan": o.id,
					"data-active": u ? "true" : "false",
					children: /* @__PURE__ */ Z(Dt, {
						label: p,
						badge: a
					})
				})]
			})
		]
	});
}
//#endregion
//#region src/product-switcher/components/Rating.tsx
function kt(e) {
	return Math.max(0, Math.min(5, e || 0)) / 5 * 100;
}
function At({ rating: e, count: t }) {
	return /* @__PURE__ */ Z("div", {
		class: "ps-buyzone__rating",
		"data-ps-rating": !0,
		children: [/* @__PURE__ */ Z("span", {
			class: "ps-stars",
			role: "img",
			"aria-label": `${Math.max(0, Math.min(5, e || 0)).toFixed(1)} out of 5 stars`,
			children: [/* @__PURE__ */ Z("span", {
				class: "ps-stars__track",
				"aria-hidden": "true",
				children: "★★★★★"
			}), /* @__PURE__ */ Z("span", {
				class: "ps-stars__fill",
				"aria-hidden": "true",
				style: { width: `${kt(e)}%` },
				children: "★★★★★"
			})]
		}), /* @__PURE__ */ Z("span", {
			class: "ps-rating-count",
			children: [
				"(",
				t,
				")"
			]
		})]
	});
}
//#endregion
//#region src/product-switcher/components/BlockRenderer.tsx
function jt({ block: e }) {
	let t = X(null);
	return Y(() => {
		let n = t.current;
		n && e.settings.nodes.forEach((e) => {
			n.appendChild(e);
		});
	}, [e]), /* @__PURE__ */ Z("div", {
		"data-ps-app-block": !0,
		ref: t
	});
}
function Mt({ block: e, shared: t }) {
	switch (e.type) {
		case "_ps-title": return /* @__PURE__ */ Z(Tt, {
			block: e,
			product: t.product
		});
		case "_ps-rating": return /* @__PURE__ */ Z(At, {
			rating: t.product.rating,
			count: t.product.ratingCount
		});
		case "_ps-price": return /* @__PURE__ */ Z(et, {
			product: t.product,
			qty: t.qty,
			cartCanCount: t.cartCanCount,
			tiers: t.bundleTiers,
			subPct: t.subPct,
			showPerUnit: t.showPerUnit
		});
		case "_ps-skio": return /* @__PURE__ */ Z(Ot, {
			plans: t.product.sellingPlans,
			activePlanId: t.planId,
			onChange: t.onPlan,
			oneTimeLabel: e.settings.one_time_label,
			subscribeLabel: e.settings.subscribe_label,
			subscribeBadge: e.settings.subscribe_badge
		});
		case "_ps-text": return /* @__PURE__ */ Z(Ct, { block: e });
		case "_ps-buy-row": return /* @__PURE__ */ Z(Fe, {
			block: e,
			product: t.product,
			qty: t.qty,
			onQty: t.onQty,
			onOption: t.onOption,
			planId: t.planId,
			pending: t.pending,
			error: t.error,
			onSubmit: t.onSubmit,
			klaviyoCompanyId: t.klaviyoCompanyId,
			addingToCartLabel: t.addingToCartLabel,
			bundleEligible: t.bundleEligible
		});
		case "_ps-made-in-usa": return /* @__PURE__ */ Z(He, { block: e });
		case "_ps-description": return /* @__PURE__ */ Z(ze, {
			html: t.product.descriptionHtml,
			ingredients: t.product.ingredients
		});
		case "_ps-usp": return /* @__PURE__ */ Z(Et, { usps: t.product.usps });
		case "_ps-ingredients": return /* @__PURE__ */ Z(Ve, {
			block: e,
			nutritionFactsImage: t.product.nutritionFactsImage,
			ingredients: t.product.ingredients
		});
		case "_ps-sugar-image": return /* @__PURE__ */ Z(xt, { block: e });
		case "_ps-review-marquee": return /* @__PURE__ */ Z(vt, {
			block: e,
			product: t.product,
			okendoStoreId: t.okendoStoreId
		});
		case "_ps-okendo": return /* @__PURE__ */ Z(Je, {
			productId: t.product.id,
			snippetHtml: t.product.okendoReviewsHtml
		});
		case "@app": return /* @__PURE__ */ Z(jt, { block: e });
	}
}
//#endregion
//#region node_modules/.pnpm/embla-carousel@8.6.0/node_modules/embla-carousel/esm/embla-carousel.esm.js
function Nt(e) {
	return typeof e == "number";
}
function Pt(e) {
	return typeof e == "string";
}
function Ft(e) {
	return typeof e == "boolean";
}
function It(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Q(e) {
	return Math.abs(e);
}
function Lt(e) {
	return Math.sign(e);
}
function Rt(e, t) {
	return Q(e - t);
}
function zt(e, t) {
	return e === 0 || t === 0 || Q(e) <= Q(t) ? 0 : Q(Rt(Q(e), Q(t)) / e);
}
function Bt(e) {
	return Math.round(e * 100) / 100;
}
function Vt(e) {
	return Gt(e).map(Number);
}
function $(e) {
	return e[Ht(e)];
}
function Ht(e) {
	return Math.max(0, e.length - 1);
}
function Ut(e, t) {
	return t === Ht(e);
}
function Wt(e, t = 0) {
	return Array.from(Array(e), (e, n) => t + n);
}
function Gt(e) {
	return Object.keys(e);
}
function Kt(e, t) {
	return [e, t].reduce((e, t) => (Gt(t).forEach((n) => {
		let r = e[n], i = t[n];
		e[n] = It(r) && It(i) ? Kt(r, i) : i;
	}), e), {});
}
function qt(e, t) {
	return t.MouseEvent !== void 0 && e instanceof t.MouseEvent;
}
function Jt(e, t) {
	let n = {
		start: r,
		center: i,
		end: a
	};
	function r() {
		return 0;
	}
	function i(e) {
		return a(e) / 2;
	}
	function a(e) {
		return t - e;
	}
	function o(r, i) {
		return Pt(e) ? n[e](r) : e(t, r, i);
	}
	return { measure: o };
}
function Yt() {
	let e = [];
	function t(t, n, i, a = { passive: !0 }) {
		let o;
		if ("addEventListener" in t) t.addEventListener(n, i, a), o = () => t.removeEventListener(n, i, a);
		else {
			let e = t;
			e.addListener(i), o = () => e.removeListener(i);
		}
		return e.push(o), r;
	}
	function n() {
		e = e.filter((e) => e());
	}
	let r = {
		add: t,
		clear: n
	};
	return r;
}
function Xt(e, t, n, r) {
	let i = Yt(), a = 1e3 / 60, o = null, s = 0, c = 0;
	function l() {
		i.add(e, "visibilitychange", () => {
			e.hidden && m();
		});
	}
	function u() {
		p(), i.clear();
	}
	function d(e) {
		if (!c) return;
		o || (o = e, n(), n());
		let i = e - o;
		for (o = e, s += i; s >= a;) n(), s -= a;
		r(s / a), c && (c = t.requestAnimationFrame(d));
	}
	function f() {
		c || (c = t.requestAnimationFrame(d));
	}
	function p() {
		t.cancelAnimationFrame(c), o = null, s = 0, c = 0;
	}
	function m() {
		o = null, s = 0;
	}
	return {
		init: l,
		destroy: u,
		start: f,
		stop: p,
		update: n,
		render: r
	};
}
function Zt(e, t) {
	let n = t === "rtl", r = e === "y", i = r ? "y" : "x", a = r ? "x" : "y", o = !r && n ? -1 : 1, s = u(), c = d();
	function l(e) {
		let { height: t, width: n } = e;
		return r ? t : n;
	}
	function u() {
		return r ? "top" : n ? "right" : "left";
	}
	function d() {
		return r ? "bottom" : n ? "left" : "right";
	}
	function f(e) {
		return e * o;
	}
	return {
		scroll: i,
		cross: a,
		startEdge: s,
		endEdge: c,
		measureSize: l,
		direction: f
	};
}
function Qt(e = 0, t = 0) {
	let n = Q(e - t);
	function r(t) {
		return t < e;
	}
	function i(e) {
		return e > t;
	}
	function a(e) {
		return r(e) || i(e);
	}
	function o(n) {
		return a(n) ? r(n) ? e : t : n;
	}
	function s(e) {
		return n ? e - n * Math.ceil((e - t) / n) : e;
	}
	return {
		length: n,
		max: t,
		min: e,
		constrain: o,
		reachedAny: a,
		reachedMax: i,
		reachedMin: r,
		removeOffset: s
	};
}
function $t(e, t, n) {
	let { constrain: r } = Qt(0, e), i = e + 1, a = o(t);
	function o(e) {
		return n ? Q((i + e) % i) : r(e);
	}
	function s() {
		return a;
	}
	function c(e) {
		return a = o(e), d;
	}
	function l(e) {
		return u().set(s() + e);
	}
	function u() {
		return $t(e, s(), n);
	}
	let d = {
		get: s,
		set: c,
		add: l,
		clone: u
	};
	return d;
}
function en(e, t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v) {
	let { cross: y, direction: b } = e, x = [
		"INPUT",
		"SELECT",
		"TEXTAREA"
	], S = { passive: !1 }, C = Yt(), w = Yt(), T = Qt(50, 225).constrain(p.measure(20)), E = {
		mouse: 300,
		touch: 400
	}, D = {
		mouse: 500,
		touch: 600
	}, O = m ? 43 : 25, ee = !1, k = 0, A = 0, j = !1, M = !1, N = !1, P = !1;
	function F(e) {
		if (!v) return;
		function n(t) {
			(Ft(v) || v(e, t)) && z(t);
		}
		let r = t;
		C.add(r, "dragstart", (e) => e.preventDefault(), S).add(r, "touchmove", () => void 0, S).add(r, "touchend", () => void 0).add(r, "touchstart", n).add(r, "mousedown", n).add(r, "touchcancel", V).add(r, "contextmenu", V).add(r, "click", H, !0);
	}
	function I() {
		C.clear(), w.clear();
	}
	function L() {
		let e = P ? n : t;
		w.add(e, "touchmove", B, S).add(e, "touchend", V).add(e, "mousemove", B, S).add(e, "mouseup", V);
	}
	function te(e) {
		let t = e.nodeName || "";
		return x.includes(t);
	}
	function ne() {
		return (m ? D : E)[P ? "mouse" : "touch"];
	}
	function R(e, t) {
		let n = d.add(Lt(e) * -1), r = u.byDistance(e, !m).distance;
		return m || Q(e) < T ? r : g && t ? r * .5 : u.byIndex(n.get(), 0).distance;
	}
	function z(e) {
		let t = qt(e, r);
		P = t, N = m && t && !e.buttons && ee, ee = Rt(i.get(), o.get()) >= 2, !(t && e.button !== 0) && (te(e.target) || (j = !0, a.pointerDown(e), l.useFriction(0).useDuration(0), i.set(o), L(), k = a.readPoint(e), A = a.readPoint(e, y), f.emit("pointerDown")));
	}
	function B(e) {
		if (!qt(e, r) && e.touches.length >= 2) return V(e);
		let t = a.readPoint(e), n = a.readPoint(e, y), o = Rt(t, k), c = Rt(n, A);
		if (!M && !P && (!e.cancelable || (M = o > c, !M))) return V(e);
		let u = a.pointerMove(e);
		o > h && (N = !0), l.useFriction(.3).useDuration(.75), s.start(), i.add(b(u)), e.preventDefault();
	}
	function V(e) {
		let t = u.byDistance(0, !1).index !== d.get(), n = a.pointerUp(e) * ne(), r = R(b(n), t), i = zt(n, r), o = O - 10 * i, s = _ + i / 50;
		M = !1, j = !1, w.clear(), l.useDuration(o).useFriction(s), c.distance(r, !m), P = !1, f.emit("pointerUp");
	}
	function H(e) {
		N && (e.stopPropagation(), e.preventDefault(), N = !1);
	}
	function U() {
		return j;
	}
	return {
		init: F,
		destroy: I,
		pointerDown: U
	};
}
function tn(e, t) {
	let n, r;
	function i(e) {
		return e.timeStamp;
	}
	function a(n, r) {
		let i = `client${(r || e.scroll) === "x" ? "X" : "Y"}`;
		return (qt(n, t) ? n : n.touches[0])[i];
	}
	function o(e) {
		return n = e, r = e, a(e);
	}
	function s(e) {
		let t = a(e) - a(r), o = i(e) - i(n) > 170;
		return r = e, o && (n = e), t;
	}
	function c(e) {
		if (!n || !r) return 0;
		let t = a(r) - a(n), o = i(e) - i(n), s = i(e) - i(r) > 170, c = t / o;
		return o && !s && Q(c) > .1 ? c : 0;
	}
	return {
		pointerDown: o,
		pointerMove: s,
		pointerUp: c,
		readPoint: a
	};
}
function nn() {
	function e(e) {
		let { offsetTop: t, offsetLeft: n, offsetWidth: r, offsetHeight: i } = e;
		return {
			top: t,
			right: n + r,
			bottom: t + i,
			left: n,
			width: r,
			height: i
		};
	}
	return { measure: e };
}
function rn(e) {
	function t(t) {
		return t / 100 * e;
	}
	return { measure: t };
}
function an(e, t, n, r, i, a, o) {
	let s = [e].concat(r), c, l, u = [], d = !1;
	function f(e) {
		return i.measureSize(o.measure(e));
	}
	function p(i) {
		if (!a) return;
		l = f(e), u = r.map(f);
		function o(n) {
			for (let a of n) {
				if (d) return;
				let n = a.target === e, o = r.indexOf(a.target), s = n ? l : u[o];
				if (Q(f(n ? e : r[o]) - s) >= .5) {
					i.reInit(), t.emit("resize");
					break;
				}
			}
		}
		c = new ResizeObserver((e) => {
			(Ft(a) || a(i, e)) && o(e);
		}), n.requestAnimationFrame(() => {
			s.forEach((e) => c.observe(e));
		});
	}
	function m() {
		d = !0, c && c.disconnect();
	}
	return {
		init: p,
		destroy: m
	};
}
function on(e, t, n, r, i, a) {
	let o = 0, s = 0, c = i, l = a, u = e.get(), d = 0;
	function f() {
		let t = r.get() - e.get(), i = !c, a = 0;
		return i ? (o = 0, n.set(r), e.set(r), a = t) : (n.set(e), o += t / c, o *= l, u += o, e.add(o), a = u - d), s = Lt(a), d = u, x;
	}
	function p() {
		return Q(r.get() - t.get()) < .001;
	}
	function m() {
		return c;
	}
	function h() {
		return s;
	}
	function g() {
		return o;
	}
	function _() {
		return y(i);
	}
	function v() {
		return b(a);
	}
	function y(e) {
		return c = e, x;
	}
	function b(e) {
		return l = e, x;
	}
	let x = {
		direction: h,
		duration: m,
		velocity: g,
		seek: f,
		settled: p,
		useBaseFriction: v,
		useBaseDuration: _,
		useFriction: b,
		useDuration: y
	};
	return x;
}
function sn(e, t, n, r, i) {
	let a = i.measure(10), o = i.measure(50), s = Qt(.1, .99), c = !1;
	function l() {
		return !(c || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
	}
	function u(i) {
		if (!l()) return;
		let c = Q(e[e.reachedMin(t.get()) ? "min" : "max"] - t.get()), u = n.get() - t.get(), d = s.constrain(c / o);
		n.subtract(u * d), !i && Q(u) < a && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
	}
	function d(e) {
		c = !e;
	}
	return {
		shouldConstrain: l,
		constrain: u,
		toggleActive: d
	};
}
function cn(e, t, n, r, i) {
	let a = Qt(-t + e, 0), o = d(), s = u(), c = f();
	function l(e, t) {
		return Rt(e, t) <= 1;
	}
	function u() {
		let e = o[0], t = $(o);
		return Qt(o.lastIndexOf(e), o.indexOf(t) + 1);
	}
	function d() {
		return n.map((e, t) => {
			let { min: r, max: i } = a, o = a.constrain(e), s = !t, c = Ut(n, t);
			return s ? i : c || l(r, o) ? r : l(i, o) ? i : o;
		}).map((e) => parseFloat(e.toFixed(3)));
	}
	function f() {
		if (t <= e + i) return [a.max];
		if (r === "keepSnaps") return o;
		let { min: n, max: c } = s;
		return o.slice(n, c);
	}
	return {
		snapsContained: c,
		scrollContainLimit: s
	};
}
function ln(e, t, n) {
	let r = t[0];
	return { limit: Qt(n ? r - e : $(t), r) };
}
function un(e, t, n, r) {
	let i = .1, { reachedMin: a, reachedMax: o } = Qt(t.min + i, t.max + i);
	function s(e) {
		return e === 1 ? o(n.get()) : e === -1 ? a(n.get()) : !1;
	}
	function c(t) {
		if (!s(t)) return;
		let n = t * -1 * e;
		r.forEach((e) => e.add(n));
	}
	return { loop: c };
}
function dn(e) {
	let { max: t, length: n } = e;
	function r(e) {
		let r = e - t;
		return n ? r / -n : 0;
	}
	return { get: r };
}
function fn(e, t, n, r, i) {
	let { startEdge: a, endEdge: o } = e, { groupSlides: s } = i, c = d().map(t.measure), l = f(), u = p();
	function d() {
		return s(r).map((e) => $(e)[o] - e[0][a]).map(Q);
	}
	function f() {
		return r.map((e) => n[a] - e[a]).map((e) => -Q(e));
	}
	function p() {
		return s(l).map((e) => e[0]).map((e, t) => e + c[t]);
	}
	return {
		snaps: l,
		snapsAligned: u
	};
}
function pn(e, t, n, r, i, a) {
	let { groupSlides: o } = i, { min: s, max: c } = r, l = u();
	function u() {
		let r = o(a), i = !e || t === "keepSnaps";
		return n.length === 1 ? [a] : i ? r : r.slice(s, c).map((e, t, n) => {
			let r = !t, i = Ut(n, t);
			return r ? Wt($(n[0]) + 1) : i ? Wt(Ht(a) - $(n)[0] + 1, $(n)[0]) : e;
		});
	}
	return { slideRegistry: l };
}
function mn(e, t, n, r, i) {
	let { reachedAny: a, removeOffset: o, constrain: s } = r;
	function c(e) {
		return e.concat().sort((e, t) => Q(e) - Q(t))[0];
	}
	function l(n) {
		let r = e ? o(n) : s(n), { index: i } = t.map((e, t) => ({
			diff: u(e - r, 0),
			index: t
		})).sort((e, t) => Q(e.diff) - Q(t.diff))[0];
		return {
			index: i,
			distance: r
		};
	}
	function u(t, r) {
		let i = [
			t,
			t + n,
			t - n
		];
		if (!e) return t;
		if (!r) return c(i);
		let a = i.filter((e) => Lt(e) === r);
		return a.length ? c(a) : $(i) - n;
	}
	function d(e, n) {
		return {
			index: e,
			distance: u(t[e] - i.get(), n)
		};
	}
	function f(n, r) {
		let o = i.get() + n, { index: s, distance: c } = l(o), d = !e && a(o);
		return !r || d ? {
			index: s,
			distance: n
		} : {
			index: s,
			distance: n + u(t[s] - c, 0)
		};
	}
	return {
		byDistance: f,
		byIndex: d,
		shortcut: u
	};
}
function hn(e, t, n, r, i, a, o) {
	function s(i) {
		let s = i.distance, c = i.index !== t.get();
		a.add(s), s && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), c && (n.set(t.get()), t.set(i.index), o.emit("select"));
	}
	function c(e, t) {
		s(i.byDistance(e, t));
	}
	function l(e, n) {
		let r = t.clone().set(e);
		s(i.byIndex(r.get(), n));
	}
	return {
		distance: c,
		index: l
	};
}
function gn(e, t, n, r, i, a, o, s) {
	let c = {
		passive: !0,
		capture: !0
	}, l = 0;
	function u(u) {
		if (!s) return;
		function f(t) {
			if ((/* @__PURE__ */ new Date()).getTime() - l > 10) return;
			o.emit("slideFocusStart"), e.scrollLeft = 0;
			let a = n.findIndex((e) => e.includes(t));
			Nt(a) && (i.useDuration(0), r.index(a, 0), o.emit("slideFocus"));
		}
		a.add(document, "keydown", d, !1), t.forEach((e, t) => {
			a.add(e, "focus", (e) => {
				(Ft(s) || s(u, e)) && f(t);
			}, c);
		});
	}
	function d(e) {
		e.code === "Tab" && (l = (/* @__PURE__ */ new Date()).getTime());
	}
	return { init: u };
}
function _n(e) {
	let t = e;
	function n() {
		return t;
	}
	function r(e) {
		t = o(e);
	}
	function i(e) {
		t += o(e);
	}
	function a(e) {
		t -= o(e);
	}
	function o(e) {
		return Nt(e) ? e : e.get();
	}
	return {
		get: n,
		set: r,
		add: i,
		subtract: a
	};
}
function vn(e, t) {
	let n = e.scroll === "x" ? o : s, r = t.style, i = null, a = !1;
	function o(e) {
		return `translate3d(${e}px,0px,0px)`;
	}
	function s(e) {
		return `translate3d(0px,${e}px,0px)`;
	}
	function c(t) {
		if (a) return;
		let o = Bt(e.direction(t));
		o !== i && (r.transform = n(o), i = o);
	}
	function l(e) {
		a = !e;
	}
	function u() {
		a || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
	}
	return {
		clear: u,
		to: c,
		toggleActive: l
	};
}
function yn(e, t, n, r, i, a, o, s, c) {
	let l = .5, u = Vt(i), d = Vt(i).reverse(), f = _().concat(v());
	function p(e, t) {
		return e.reduce((e, t) => e - i[t], t);
	}
	function m(e, t) {
		return e.reduce((e, n) => p(e, t) > 0 ? e.concat([n]) : e, []);
	}
	function h(e) {
		return a.map((n, i) => ({
			start: n - r[i] + l + e,
			end: n + t - l + e
		}));
	}
	function g(t, r, i) {
		let a = h(r);
		return t.map((t) => {
			let r = i ? 0 : -n, o = i ? n : 0, l = i ? "end" : "start", u = a[t][l];
			return {
				index: t,
				loopPoint: u,
				slideLocation: _n(-1),
				translate: vn(e, c[t]),
				target: () => s.get() > u ? r : o
			};
		});
	}
	function _() {
		let e = o[0];
		return g(m(d, e), n, !1);
	}
	function v() {
		return g(m(u, t - o[0] - 1), -n, !0);
	}
	function y() {
		return f.every(({ index: e }) => p(u.filter((t) => t !== e), t) <= .1);
	}
	function b() {
		f.forEach((e) => {
			let { target: t, translate: n, slideLocation: r } = e, i = t();
			i !== r.get() && (n.to(i), r.set(i));
		});
	}
	function x() {
		f.forEach((e) => e.translate.clear());
	}
	return {
		canLoop: y,
		clear: x,
		loop: b,
		loopPoints: f
	};
}
function bn(e, t, n) {
	let r, i = !1;
	function a(a) {
		if (!n) return;
		function o(e) {
			for (let n of e) if (n.type === "childList") {
				a.reInit(), t.emit("slidesChanged");
				break;
			}
		}
		r = new MutationObserver((e) => {
			i || (Ft(n) || n(a, e)) && o(e);
		}), r.observe(e, { childList: !0 });
	}
	function o() {
		r && r.disconnect(), i = !0;
	}
	return {
		init: a,
		destroy: o
	};
}
function xn(e, t, n, r) {
	let i = {}, a = null, o = null, s, c = !1;
	function l() {
		s = new IntersectionObserver((e) => {
			c || (e.forEach((e) => {
				let n = t.indexOf(e.target);
				i[n] = e;
			}), a = null, o = null, n.emit("slidesInView"));
		}, {
			root: e.parentElement,
			threshold: r
		}), t.forEach((e) => s.observe(e));
	}
	function u() {
		s && s.disconnect(), c = !0;
	}
	function d(e) {
		return Gt(i).reduce((t, n) => {
			let r = parseInt(n), { isIntersecting: a } = i[r];
			return (e && a || !e && !a) && t.push(r), t;
		}, []);
	}
	function f(e = !0) {
		if (e && a) return a;
		if (!e && o) return o;
		let t = d(e);
		return e && (a = t), e || (o = t), t;
	}
	return {
		init: l,
		destroy: u,
		get: f
	};
}
function Sn(e, t, n, r, i, a) {
	let { measureSize: o, startEdge: s, endEdge: c } = e, l = n[0] && i, u = m(), d = h(), f = n.map(o), p = g();
	function m() {
		if (!l) return 0;
		let e = n[0];
		return Q(t[s] - e[s]);
	}
	function h() {
		if (!l) return 0;
		let e = a.getComputedStyle($(r));
		return parseFloat(e.getPropertyValue(`margin-${c}`));
	}
	function g() {
		return n.map((e, t, n) => {
			let r = !t, i = Ut(n, t);
			return r ? f[t] + u : i ? f[t] + d : n[t + 1][s] - e[s];
		}).map(Q);
	}
	return {
		slideSizes: f,
		slideSizesWithGaps: p,
		startGap: u,
		endGap: d
	};
}
function Cn(e, t, n, r, i, a, o, s, c) {
	let { startEdge: l, endEdge: u, direction: d } = e, f = Nt(n);
	function p(e, t) {
		return Vt(e).filter((e) => e % t === 0).map((n) => e.slice(n, n + t));
	}
	function m(e) {
		return e.length ? Vt(e).reduce((n, f, p) => {
			let m = $(n) || 0, h = m === 0, g = f === Ht(e), _ = i[l] - a[m][l], v = i[l] - a[f][u], y = !r && h ? d(o) : 0, b = Q(v - (!r && g ? d(s) : 0) - (_ + y));
			return p && b > t + c && n.push(f), g && n.push(e.length), n;
		}, []).map((t, n, r) => {
			let i = Math.max(r[n - 1] || 0);
			return e.slice(i, t);
		}) : [];
	}
	function h(e) {
		return f ? p(e, n) : m(e);
	}
	return { groupSlides: h };
}
function wn(e, t, n, r, i, a, o) {
	let { align: s, axis: c, direction: l, startIndex: u, loop: d, duration: f, dragFree: p, dragThreshold: m, inViewThreshold: h, slidesToScroll: g, skipSnaps: _, containScroll: v, watchResize: y, watchSlides: b, watchDrag: x, watchFocus: S } = a, C = nn(), w = C.measure(t), T = n.map(C.measure), E = Zt(c, l), D = E.measureSize(w), O = rn(D), ee = Jt(s, D), k = !d && !!v, { slideSizes: A, slideSizesWithGaps: j, startGap: M, endGap: N } = Sn(E, w, T, n, d || !!v, i), P = Cn(E, D, g, d, w, T, M, N, 2), { snaps: F, snapsAligned: I } = fn(E, ee, w, T, P), L = -$(F) + $(j), { snapsContained: te, scrollContainLimit: ne } = cn(D, L, I, v, 2), R = k ? te : I, { limit: z } = ln(L, R, d), B = $t(Ht(R), u, d), V = B.clone(), H = Vt(n), U = ({ dragHandler: e, scrollBody: t, scrollBounds: n, options: { loop: r } }) => {
		r || n.constrain(e.pointerDown()), t.seek();
	}, re = ({ scrollBody: e, translate: t, location: n, offsetLocation: r, previousLocation: i, scrollLooper: a, slideLooper: o, dragHandler: s, animation: c, eventHandler: l, scrollBounds: u, options: { loop: d } }, f) => {
		let p = e.settled(), m = !u.shouldConstrain(), h = d ? p : p && m, g = h && !s.pointerDown();
		g && c.stop();
		let _ = n.get() * f + i.get() * (1 - f);
		r.set(_), d && (a.loop(e.direction()), o.loop()), t.to(r.get()), g && l.emit("settle"), h || l.emit("scroll");
	}, ie = Xt(r, i, () => U(X), (e) => re(X, e)), W = .68, ae = R[B.get()], G = _n(ae), oe = _n(ae), K = _n(ae), q = _n(ae), se = on(G, K, oe, q, f, W), ce = mn(d, R, L, z, q), le = hn(ie, B, V, se, ce, q, o), ue = dn(z), J = Yt(), de = xn(t, n, o, h), { slideRegistry: Y } = pn(k, v, R, ne, P, H), fe = gn(e, n, Y, le, se, J, o, S), X = {
		ownerDocument: r,
		ownerWindow: i,
		eventHandler: o,
		containerRect: w,
		slideRects: T,
		animation: ie,
		axis: E,
		dragHandler: en(E, e, r, i, q, tn(E, i), G, ie, le, se, ce, B, o, O, p, m, _, W, x),
		eventStore: J,
		percentOfView: O,
		index: B,
		indexPrevious: V,
		limit: z,
		location: G,
		offsetLocation: K,
		previousLocation: oe,
		options: a,
		resizeHandler: an(t, o, i, n, E, y, C),
		scrollBody: se,
		scrollBounds: sn(z, K, q, se, O),
		scrollLooper: un(L, z, K, [
			G,
			K,
			oe,
			q
		]),
		scrollProgress: ue,
		scrollSnapList: R.map(ue.get),
		scrollSnaps: R,
		scrollTarget: ce,
		scrollTo: le,
		slideLooper: yn(E, D, L, A, j, F, R, K, n),
		slideFocus: fe,
		slidesHandler: bn(t, o, b),
		slidesInView: de,
		slideIndexes: H,
		slideRegistry: Y,
		slidesToScroll: P,
		target: q,
		translate: vn(E, t)
	};
	return X;
}
function Tn() {
	let e = {}, t;
	function n(e) {
		t = e;
	}
	function r(t) {
		return e[t] || [];
	}
	function i(e) {
		return r(e).forEach((n) => n(t, e)), c;
	}
	function a(t, n) {
		return e[t] = r(t).concat([n]), c;
	}
	function o(t, n) {
		return e[t] = r(t).filter((e) => e !== n), c;
	}
	function s() {
		e = {};
	}
	let c = {
		init: n,
		emit: i,
		off: o,
		on: a,
		clear: s
	};
	return c;
}
var En = {
	align: "center",
	axis: "x",
	container: null,
	slides: null,
	containScroll: "trimSnaps",
	direction: "ltr",
	slidesToScroll: 1,
	inViewThreshold: 0,
	breakpoints: {},
	dragFree: !1,
	dragThreshold: 10,
	loop: !1,
	skipSnaps: !1,
	duration: 25,
	startIndex: 0,
	active: !0,
	watchDrag: !0,
	watchResize: !0,
	watchSlides: !0,
	watchFocus: !0
};
function Dn(e) {
	function t(e, t) {
		return Kt(e, t || {});
	}
	function n(n) {
		let r = n.breakpoints || {};
		return t(n, Gt(r).filter((t) => e.matchMedia(t).matches).map((e) => r[e]).reduce((e, n) => t(e, n), {}));
	}
	function r(t) {
		return t.map((e) => Gt(e.breakpoints || {})).reduce((e, t) => e.concat(t), []).map(e.matchMedia);
	}
	return {
		mergeOptions: t,
		optionsAtMedia: n,
		optionsMediaQueries: r
	};
}
function On(e) {
	let t = [];
	function n(n, r) {
		return t = r.filter(({ options: t }) => e.optionsAtMedia(t).active !== !1), t.forEach((t) => t.init(n, e)), r.reduce((e, t) => Object.assign(e, { [t.name]: t }), {});
	}
	function r() {
		t = t.filter((e) => e.destroy());
	}
	return {
		init: n,
		destroy: r
	};
}
function kn(e, t, n) {
	let r = e.ownerDocument, i = r.defaultView, a = Dn(i), o = On(a), s = Yt(), c = Tn(), { mergeOptions: l, optionsAtMedia: u, optionsMediaQueries: d } = a, { on: f, off: p, emit: m } = c, h = D, g = !1, _, v = l(En, kn.globalOptions), y = l(v), b = [], x, S, C;
	function w() {
		let { container: t, slides: n } = y;
		S = (Pt(t) ? e.querySelector(t) : t) || e.children[0];
		let r = Pt(n) ? S.querySelectorAll(n) : n;
		C = [].slice.call(r || S.children);
	}
	function T(t) {
		let n = wn(e, S, C, r, i, t, c);
		return t.loop && !n.slideLooper.canLoop() ? T(Object.assign({}, t, { loop: !1 })) : n;
	}
	function E(e, t) {
		g || (v = l(v, e), y = u(v), b = t || b, w(), _ = T(y), d([v, ...b.map(({ options: e }) => e)]).forEach((e) => s.add(e, "change", D)), y.active && (_.translate.to(_.location.get()), _.animation.init(), _.slidesInView.init(), _.slideFocus.init(U), _.eventHandler.init(U), _.resizeHandler.init(U), _.slidesHandler.init(U), _.options.loop && _.slideLooper.loop(), S.offsetParent && C.length && _.dragHandler.init(U), x = o.init(U, b)));
	}
	function D(e, t) {
		let n = I();
		O(), E(l({ startIndex: n }, e), t), c.emit("reInit");
	}
	function O() {
		_.dragHandler.destroy(), _.eventStore.clear(), _.translate.clear(), _.slideLooper.clear(), _.resizeHandler.destroy(), _.slidesHandler.destroy(), _.slidesInView.destroy(), _.animation.destroy(), o.destroy(), s.clear();
	}
	function ee() {
		g || (g = !0, s.clear(), O(), c.emit("destroy"), c.clear());
	}
	function k(e, t, n) {
		!y.active || g || (_.scrollBody.useBaseFriction().useDuration(t === !0 ? 0 : y.duration), _.scrollTo.index(e, n || 0));
	}
	function A(e) {
		k(_.index.add(1).get(), e, -1);
	}
	function j(e) {
		k(_.index.add(-1).get(), e, 1);
	}
	function M() {
		return _.index.add(1).get() !== I();
	}
	function N() {
		return _.index.add(-1).get() !== I();
	}
	function P() {
		return _.scrollSnapList;
	}
	function F() {
		return _.scrollProgress.get(_.offsetLocation.get());
	}
	function I() {
		return _.index.get();
	}
	function L() {
		return _.indexPrevious.get();
	}
	function te() {
		return _.slidesInView.get();
	}
	function ne() {
		return _.slidesInView.get(!1);
	}
	function R() {
		return x;
	}
	function z() {
		return _;
	}
	function B() {
		return e;
	}
	function V() {
		return S;
	}
	function H() {
		return C;
	}
	let U = {
		canScrollNext: M,
		canScrollPrev: N,
		containerNode: V,
		internalEngine: z,
		destroy: ee,
		off: p,
		on: f,
		emit: m,
		plugins: R,
		previousScrollSnap: L,
		reInit: h,
		rootNode: B,
		scrollNext: A,
		scrollPrev: j,
		scrollProgress: F,
		scrollSnapList: P,
		scrollTo: k,
		selectedScrollSnap: I,
		slideNodes: H,
		slidesInView: te,
		slidesNotInView: ne
	};
	return E(t, n), setTimeout(() => c.emit("init"), 0), U;
}
kn.globalOptions = void 0;
//#endregion
//#region src/product-switcher/components/Can.tsx
var An = [
	240,
	360,
	480
], jn = [
	390,
	585,
	780
], Mn = "clamp(180px, 58vw, 240px)", Nn = "clamp(210px, 27vw, 390px)";
function Pn(e, t) {
	return e && (/[?&]width=\d+/.test(e) ? e.replace(/([?&])width=\d+/, `$1width=${t}`) : `${e}${e.includes("?") ? "&" : "?"}width=${t}`);
}
function Fn(e, t = jn) {
	return e ? t.map((t) => `${Pn(e, t)} ${t}w`).join(", ") : "";
}
function In(e) {
	return !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}
function Ln({ product: e, selected: t, distance: n, onSelect: r }) {
	return /* @__PURE__ */ Z("a", {
		href: e.url,
		class: "ps-slide",
		"data-ps-slide": !0,
		"data-product-handle": e.handle,
		"data-selected": t ? "true" : "false",
		"data-distance": String(n),
		"aria-label": e.title,
		"aria-current": t ? "page" : void 0,
		onClick: (e) => {
			In(e) && (e.preventDefault(), r());
		},
		children: /* @__PURE__ */ Z("picture", {
			class: "ps-slide__picture",
			children: [
				/* @__PURE__ */ Z("source", {
					media: "(max-width: 749px)",
					srcSet: Fn(e.image.src, An),
					sizes: Mn
				}),
				/* @__PURE__ */ Z("source", {
					media: "(min-width: 750px)",
					srcSet: Fn(e.image.src, jn),
					sizes: Nn
				}),
				/* @__PURE__ */ Z("img", {
					class: "ps-slide__img",
					src: Pn(e.image.src, 780),
					alt: e.image.alt,
					width: e.image.width,
					height: e.image.height,
					loading: t ? "eager" : "lazy",
					fetchPriority: t ? "high" : "auto",
					decoding: "async"
				})
			]
		})
	});
}
//#endregion
//#region src/product-switcher/components/CarouselNav.tsx
function Rn({ direction: e }) {
	return /* @__PURE__ */ Z("svg", {
		class: "ps-carousel-nav__caret",
		viewBox: "0 0 24 24",
		"aria-hidden": "true",
		focusable: "false",
		children: /* @__PURE__ */ Z("path", { d: e === "previous" ? "M15 4 7 12l8 8" : "m9 4 8 8-8 8" })
	});
}
function zn({ products: e, selectedIndex: t, showArrows: n, showDots: r, previousLabel: i, nextLabel: a, onPrevious: o, onNext: s, onDot: c }) {
	return !n && !r || e.length < 2 ? null : /* @__PURE__ */ Z("div", {
		class: "ps-carousel-nav",
		children: [
			n ? /* @__PURE__ */ Z("button", {
				type: "button",
				class: "ps-carousel-nav__arrow ps-carousel-nav__arrow--previous",
				"aria-label": i,
				onClick: o,
				children: /* @__PURE__ */ Z(Rn, { direction: "previous" })
			}) : null,
			r ? /* @__PURE__ */ Z("div", {
				class: "ps-carousel-nav__dots",
				children: e.map((e, n) => /* @__PURE__ */ Z("button", {
					type: "button",
					class: "ps-carousel-nav__dot",
					"aria-label": e.title,
					"aria-current": n === t ? "true" : void 0,
					onClick: () => c(e.handle)
				}, e.handle))
			}) : null,
			n ? /* @__PURE__ */ Z("button", {
				type: "button",
				class: "ps-carousel-nav__arrow ps-carousel-nav__arrow--next",
				"aria-label": a,
				onClick: s,
				children: /* @__PURE__ */ Z(Rn, { direction: "next" })
			}) : null
		]
	});
}
//#endregion
//#region src/product-switcher/components/Carousel.tsx
var Bn = {
	align: "center",
	loop: !0,
	containScroll: !1,
	skipSnaps: !1,
	dragFree: !1
}, Vn = 180, Hn = 2;
function Un(e, t) {
	return t.length ? e % t.length : -1;
}
function Wn(e, t, n) {
	let r = Math.abs(e - t);
	return n < 2 ? r : Math.min(r, n - r);
}
function Gn(e, t) {
	if (t <= 0 || !Number.isFinite(e) || e <= 0) return 1;
	let n = Math.ceil(e * Hn / Vn);
	return Math.max(1, Math.ceil(n / t));
}
function Kn(e, t, n) {
	return Math.max(0, e) + Math.floor(t / 2) * n;
}
function qn(e, t, n, r) {
	return r <= 0 ? Math.max(0, t) : e + Math.min(n - 1, Math.max(0, Math.round((t - e) / r))) * r;
}
function Jn(e, t, n, r) {
	return e == null || e < 0 || e >= n || r <= 0 ? null : e % r === t ? e : null;
}
function Yn({ products: e, selectedHandle: t, onSelect: n, nav: r }) {
	let i = X(null), a = X(null), o = X(!1), s = X(!1), c = X(null), l = X(e), u = X(t);
	l.current = e, u.current = t;
	let d = e.length, f = Math.max(0, e.findIndex((e) => e.handle === t)), [p, m] = J(() => Gn(window.innerWidth, d)), h = X(p);
	h.current = p;
	let g = X(Kn(f, p, d)), [_, v] = J(g.current), y = p * d, b = Array.from({ length: y }, (e, t) => t);
	Y(() => {
		let e = i.current;
		if (!e) return;
		let t = () => {
			let t = e.clientWidth || window.innerWidth;
			m((e) => Math.max(e, Gn(t, d)));
		};
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, [d]), Y(() => {
		if (!i.current) return;
		let e = kn(i.current, {
			...Bn,
			startIndex: g.current
		});
		return a.current = e, e.on("select", () => {
			let t = e.selectedScrollSnap();
			v(t);
			let r = l.current[Un(t, l.current)];
			r && r.handle !== u.current && n(r.handle);
		}), e.on("settle", () => {
			o.current = !1;
		}), e.on("pointerDown", () => {
			o.current = !1;
		}), () => {
			e.destroy(), a.current = null;
		};
	}, []), Y(() => {
		let e = a.current;
		if (!e) return;
		if (!s.current) {
			s.current = !0;
			return;
		}
		let t = Un(e.selectedScrollSnap(), l.current);
		e.reInit({
			...Bn,
			startIndex: Kn(t, p, d)
		}), v(e.selectedScrollSnap());
	}, [p, d]), Y(() => {
		let n = a.current;
		if (!n) return;
		let r = e.findIndex((e) => e.handle === t);
		if (r >= 0 && e[Un(n.selectedScrollSnap(), e)]?.handle !== t) {
			let e = Jn(c.current, r, h.current * d, d);
			c.current = null, o.current = !0, n.scrollTo(e ?? qn(r, n.selectedScrollSnap(), h.current, d));
		}
	}, [t, e]);
	let x = (e, r) => {
		if (o.current) return;
		let i = a.current;
		if (e === t) {
			o.current = !0, i?.scrollTo(r);
			return;
		}
		o.current = !0, c.current = r, n(e);
	};
	return /* @__PURE__ */ Z("div", {
		class: "ps-carousel",
		"data-ps-carousel": !0,
		children: [/* @__PURE__ */ Z("div", {
			class: "ps-carousel__viewport",
			ref: i,
			children: /* @__PURE__ */ Z("div", {
				class: "ps-carousel__track",
				children: b.map((t) => {
					let n = e[Un(t, e)], r = Math.min(2, Wn(t, _, y));
					return /* @__PURE__ */ Z(Ln, {
						product: n,
						selected: t === _,
						distance: r,
						onSelect: () => x(n.handle, t)
					}, t);
				})
			})
		}), /* @__PURE__ */ Z(zn, {
			...r,
			products: e,
			selectedIndex: f,
			onPrevious: () => a.current?.scrollPrev(),
			onNext: () => a.current?.scrollNext(),
			onDot: n
		})]
	});
}
//#endregion
//#region src/product-switcher/components/LowStockBadge.tsx
function Xn(e, t, n) {
	return !t || n <= 0 || !Number.isFinite(e) ? !1 : e > 0 && e <= n;
}
function Zn({ inventoryQuantity: e, inventoryManaged: t, threshold: n, label: r }) {
	return Xn(e, t, n) ? /* @__PURE__ */ Z("span", {
		class: "low-stock-badge",
		"data-ps-low-stock": !0,
		children: r
	}) : null;
}
//#endregion
//#region src/product-switcher/hooks/useAccent.ts
var Qn = "ps-accent-header", $n = .5, er = null, tr = 0;
function nr(e) {
	let t = e.replace("#", "").trim(), n = (t.length === 3 ? t.split("").map((e) => e + e).join("") : t).match(/^([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
	return n ? [
		parseInt(n[1], 16),
		parseInt(n[2], 16),
		parseInt(n[3], 16)
	] : [
		0,
		0,
		0
	];
}
function rr([e, t, n]) {
	let r = (e) => {
		let t = e / 255;
		return t <= .03928 ? t / 12.92 : ((t + .055) / 1.055) ** 2.4;
	};
	return .2126 * r(e) + .7152 * r(t) + .0722 * r(n);
}
function ir(e, t, n, r) {
	return `
#header-component {
  --header-accent: ${e};
  --header-accent-rgb-space: ${t.replace(/,\s*/g, " ")};
  --header-accent-fg: ${n};
  --header-accent-fg-rgb-space: ${r.replace(/,\s*/g, " ")};
}
`;
}
function ar(e, t, n) {
	let r = X(null), i = X(!1);
	Y(() => {
		if (!e) return;
		let a = nr(t), o = rr(a) > $n, s = o ? "#000" : "#fff", c = o ? "0, 0, 0" : "255, 255, 255", l = a.join(", ");
		if (e.style.setProperty("--accent", t), e.style.setProperty("--accent-fg", s), e.style.setProperty("--accent-ink", o ? `color-mix(in srgb, ${t} 75%, black)` : t), !n) return;
		let u = r.current;
		u || (u = document.getElementById(Qn), u || (u = document.createElement("style"), u.id = Qn, document.head.appendChild(u), er = u), u === er && (tr += 1, i.current = !0), r.current = u), u.textContent = ir(t, l, s, c);
	}, [
		e,
		t,
		n
	]), Y(() => () => {
		r.current && i.current && (tr = Math.max(0, tr - 1), tr === 0 && r.current === er && (r.current.remove(), er = null)), r.current = null, i.current = !1;
	}, []);
}
//#endregion
//#region src/product-switcher/lib/cartRoutes.ts
function or() {
	return globalThis.Theme?.routes;
}
function sr() {
	return or()?.cart_add_url || "/cart/add.js";
}
function cr() {
	return `${or()?.cart_url || "/cart"}.js`;
}
//#endregion
//#region src/product-switcher/hooks/useCart.ts
function lr() {
	let e = /* @__PURE__ */ new Set();
	return document.querySelectorAll("cart-items-component[data-section-id]").forEach((t) => {
		let n = t.dataset.sectionId;
		n && e.add(n);
	}), Array.from(e).join(",");
}
async function ur() {
	let e = await fetch(cr(), { headers: { Accept: "application/json" } });
	if (!e.ok) throw Error(`Cart refresh failed (${e.status})`);
	return await e.json();
}
function dr(e) {
	return {
		item_count: e.items.reduce((e, t) => e + t.quantity, 0),
		items: e.items
	};
}
function fr(e, t, n) {
	let r = new CustomEvent("cart:update", {
		bubbles: !0,
		detail: {
			resource: t,
			sourceId: "product-switcher",
			data: {
				source: "product-switcher",
				itemCount: t.item_count,
				productId: String(e),
				sections: n
			}
		}
	});
	document.dispatchEvent(r);
}
function pr() {
	document.querySelector("cart-drawer-component")?.open?.();
}
function mr() {
	let [e, t] = J(!1), [n, r] = J(null);
	return {
		addToCart: me(async (e, n) => {
			t(!0), r(null);
			try {
				let t = lr(), r = { items: [e] };
				t && (r.sections = t);
				let i = await fetch(sr(), {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/json"
					},
					body: JSON.stringify(r)
				});
				if (!i.ok) {
					let e = await i.json().catch(() => ({}));
					throw Error(e?.description || `Cart add failed (${i.status})`);
				}
				let a = await i.json();
				return fr(n, await ur().catch(() => dr(a)), a.sections), pr(), a;
			} catch (e) {
				throw r(e instanceof Error ? e.message : "Cart add failed"), e;
			} finally {
				t(!1);
			}
		}, []),
		pending: e,
		error: n
	};
}
//#endregion
//#region src/product-switcher/hooks/useCartCans.ts
var hr = 80;
function gr(e) {
	return (e || "").trim().toLowerCase();
}
function _r(e) {
	let [t, n] = J(0), r = X(null), i = X(null), a = me(async () => {
		i.current?.abort();
		let t = new AbortController();
		i.current = t;
		try {
			let r = await fetch(cr(), {
				headers: { Accept: "application/json" },
				signal: t.signal
			});
			if (!r.ok) throw Error(`cart.js ${r.status}`);
			let i = await r.json(), a = gr(e);
			n((i.items || []).reduce((e, t) => gr(t?.product_type) === a ? e + (Number(t.quantity) || 0) : e, 0));
		} catch (e) {
			if (e?.name === "AbortError") return;
			console.warn("[product-switcher] cart count fetch failed", e), n(0);
		}
	}, [e]), o = me(() => {
		r.current && clearTimeout(r.current), r.current = setTimeout(() => {
			r.current = null, a();
		}, hr);
	}, [a]);
	return Y(() => {
		a();
		let e = () => o();
		return document.addEventListener("cart:update", e), () => {
			document.removeEventListener("cart:update", e), r.current && clearTimeout(r.current), i.current?.abort();
		};
	}, [a, o]), {
		cartCanCount: t,
		refresh: o
	};
}
//#endregion
//#region src/product-switcher/hooks/useProductSeo.ts
function vr(e) {
	try {
		return new URL(e, window.location.origin).href;
	} catch {
		return e;
	}
}
function yr(e) {
	return e.startsWith("//") ? `${window.location.protocol}${e}` : vr(e);
}
function br(e) {
	return (Math.max(0, e) / 100).toFixed(2);
}
function xr(e, t, n) {
	let r = document.head.querySelector(e);
	r && r.setAttribute(t, n);
}
function Sr(e, t) {
	let n = e.seo?.title || e.title;
	return !t || n.includes(t) ? n : `${n} - ${t}`;
}
function Cr(e) {
	return e.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}
function wr(e) {
	return e.seo?.description || Cr(e.descriptionHtml);
}
function Tr(e, t) {
	let n = e.seo?.image || e.image;
	return {
		canonicalUrl: vr(e.seo?.canonicalUrl || e.url),
		title: Sr(e, t),
		description: wr(e),
		imageUrl: yr(n.src),
		imageWidth: String(n.width),
		imageHeight: String(n.height),
		price: br(e.price),
		currency: e.currency,
		product: e
	};
}
function Er(e) {
	let { product: t } = e, n = {
		"@context": "https://schema.org",
		"@type": "Product",
		"@id": `${e.canonicalUrl}#product`,
		name: t.title,
		description: e.description,
		image: [e.imageUrl],
		url: e.canonicalUrl,
		offers: {
			"@type": "Offer",
			url: e.canonicalUrl,
			priceCurrency: e.currency,
			price: e.price,
			availability: t.available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
			itemCondition: "https://schema.org/NewCondition"
		}
	};
	return t.vendor && (n.brand = {
		"@type": "Brand",
		name: t.vendor
	}), t.sku && (n.sku = t.sku), t.rating > 0 && t.ratingCount > 0 && (n.aggregateRating = {
		"@type": "AggregateRating",
		ratingValue: t.rating,
		reviewCount: t.ratingCount
	}), n;
}
function Dr(e) {
	let t = [
		[
			"link[rel=\"canonical\"]",
			"href",
			e.canonicalUrl
		],
		[
			"meta[name=\"description\"]",
			"content",
			e.description
		],
		[
			"meta[property=\"og:url\"]",
			"content",
			e.canonicalUrl
		],
		[
			"meta[property=\"og:title\"]",
			"content",
			e.title
		],
		[
			"meta[property=\"og:type\"]",
			"content",
			"product"
		],
		[
			"meta[property=\"og:description\"]",
			"content",
			e.description
		],
		[
			"meta[property=\"og:image\"]",
			"content",
			e.imageUrl
		],
		[
			"meta[property=\"og:image:secure_url\"]",
			"content",
			e.imageUrl
		],
		[
			"meta[property=\"og:image:width\"]",
			"content",
			e.imageWidth
		],
		[
			"meta[property=\"og:image:height\"]",
			"content",
			e.imageHeight
		],
		[
			"meta[property=\"og:price:amount\"]",
			"content",
			e.price
		],
		[
			"meta[property=\"og:price:currency\"]",
			"content",
			e.currency
		],
		[
			"meta[name=\"twitter:title\"]",
			"content",
			e.title
		],
		[
			"meta[name=\"twitter:description\"]",
			"content",
			e.description
		],
		[
			"meta[name=\"twitter:image\"]",
			"content",
			e.imageUrl
		]
	];
	document.title = e.title, t.forEach(([e, t, n]) => {
		xr(e, t, n);
	});
}
function Or(e) {
	let t = document.getElementById("product-switcher-product-json-ld");
	t || (t = document.createElement("script"), t.id = "product-switcher-product-json-ld", t.type = "application/ld+json", document.head.append(t));
	let n = JSON.stringify(Er(e));
	t.textContent !== n && (t.textContent = n);
}
function kr(e, t, n) {
	Y(() => {
		if (!n || !e) return;
		let r = Tr(e, t);
		Dr(r), Or(r);
	}, [
		n,
		e,
		t
	]);
}
//#endregion
//#region src/product-switcher/hooks/useUrlSync.ts
function Ar(e) {
	let t = history.state;
	return {
		...t && typeof t == "object" ? t : {},
		handle: e
	};
}
function jr(e, t, n) {
	let r = X(!0), i = X(!1);
	Y(() => {
		if (r.current) {
			r.current = !1, e && history.replaceState(Ar(e), "");
			return;
		}
		if (i.current) {
			i.current = !1;
			return;
		}
		let n = t.find((t) => t.handle === e);
		n && window.location.pathname !== new URL(n.url, window.location.origin).pathname && history.pushState(Ar(e), "", n.url);
	}, [t, e]), Y(() => {
		let e = (e) => {
			let r = e.state?.handle, a = window.location.pathname.split("/products/")[1]?.split(/[/?]/)[0], o = r || a;
			o && t.some((e) => e.handle === o) && (i.current = !0, n(o));
		};
		return window.addEventListener("popstate", e), () => window.removeEventListener("popstate", e);
	}, [t, n]);
}
//#endregion
//#region src/product-switcher/lib/variants.ts
function Mr(e, t) {
	if (!e) return;
	let n = e.variants.find((e) => e.id === t);
	return n ? {
		...e,
		sku: n.sku,
		price: n.price,
		compareAtPrice: n.compareAtPrice,
		variantId: n.id,
		variantTitle: n.title,
		available: n.available,
		inventoryQuantity: n.inventoryQuantity,
		inventoryManaged: n.inventoryManaged
	} : e;
}
function Nr(e, t, n, r) {
	let i = e.variants.filter((e) => e.options[n] === r);
	return i.find((e) => e.available && t?.options.every((t, r) => r === n || e.options[r] === t)) || i.find((e) => e.available) || i[0];
}
//#endregion
//#region src/product-switcher/App.tsx
function Pr(e) {
	let t = e.blocks.find((e) => e.type === "_ps-buy-row");
	return t ? Math.max(1, Math.floor(Number(t.settings.qty_min) || 1)) : 1;
}
function Fr(e, t) {
	return e && t?.bundleEligible === !0;
}
function Ir(e, t, n) {
	if (!t) return n;
	let r = Number(t.priceAdjustmentValue);
	if (!Number.isFinite(r)) return n;
	switch (t.priceAdjustmentType) {
		case "percentage": return r;
		case "fixed_amount": return e > 0 ? r / e * 100 : 0;
		case "price": return e > 0 ? (e - r) / e * 100 : 0;
	}
}
function Lr(e, t) {
	return !e || t == null ? null : e.sellingPlans.some((e) => e.id === t) ? t : null;
}
function Rr({ root: e, products: t, config: n }) {
	let r = pe(() => new Map(t.map((e) => [e.handle, e])), [t]), i = (r.has(n.initialHandle) ? n.initialHandle : t[0]?.handle) || "", [a, o] = J(i), [s, c] = J(i), [l, u] = J(!1), d = pe(() => Pr(n), [n]), [f, p] = J((r.get(i) || t[0])?.variantId ?? null), [m, h] = J(d), [g, _] = J(null), [v, y] = J(""), b = r.get(s) || t[0], x = Mr(b, f), S = b?.variants.find((e) => e.id === x?.variantId);
	Y(() => {
		p(b?.variantId ?? null);
	}, [b?.handle, b?.variantId]);
	let C = X(s);
	Y(() => {
		C.current = s;
	}, [s]);
	let w = X(null), T = X(null);
	Y(() => {
		if (!(!a || a === C.current)) return w.current != null && window.clearTimeout(w.current), T.current != null && window.cancelAnimationFrame(T.current), u(!0), w.current = window.setTimeout(() => {
			c(a), T.current = window.requestAnimationFrame(() => {
				u(!1);
			});
		}, 120), () => {
			w.current != null && window.clearTimeout(w.current), T.current != null && window.cancelAnimationFrame(T.current);
		};
	}, [a]);
	let E = X(x?.handle);
	Y(() => {
		x && x.handle !== E.current && (E.current = x.handle, h(Fr(n.bundleEnabled, x) ? d : 1), _(null), y(`${x.title}. ${x.available ? n.inStockLabel : n.outOfStockLabel}. ${$e(x.price, x.currency)}.`));
	}, [
		d,
		n.bundleEnabled,
		n.inStockLabel,
		n.outOfStockLabel,
		x
	]), ar(e, x?.accent || "#1f2937", n.recolorHeader), kr(x, n.shopName, n.updateSeo), jr(a, t, o);
	let { addToCart: D, pending: O, error: ee } = mr(), { cartCanCount: k } = _r(n.canProductType), A = Fr(n.bundleEnabled, x), j = {
		eligible: A,
		qty: A ? m : 1,
		tiers: A ? n.bundleTiers : [],
		cartCanCount: A ? k : 0
	}, M = pe(() => Lr(x, g), [x, g]), N = pe(() => {
		if (M == null || !x) return 0;
		let e = x.sellingPlans.find((e) => e.id === M);
		return Ir(x.price, e, n.subscriptionDiscountPct);
	}, [
		n.subscriptionDiscountPct,
		M,
		x
	]), P = n.blocks.find((e) => e.type === "_ps-rating"), F = n.blocks.find((e) => e.type === "_ps-text"), I = n.blocks.filter((e) => e.type === "_ps-title"), L = n.blocks.filter((e) => e.type !== "_ps-rating" && e.type !== "_ps-text" && e.type !== "_ps-title"), te = me(async (e) => {
		if (e.preventDefault(), x) try {
			await D({
				id: x.variantId,
				quantity: j.qty,
				...M ? { selling_plan: M } : {}
			}, x.id);
		} catch {}
	}, [
		x,
		j.qty,
		M,
		D
	]), ne = me((e, t) => {
		if (!b) return;
		let n = Nr(b, S, e, t);
		n && p(n.id);
	}, [b, S]);
	if (!x) return null;
	let R = {
		product: x,
		qty: j.qty,
		onQty: h,
		onOption: ne,
		planId: M,
		onPlan: _,
		pending: O,
		error: ee,
		onSubmit: te,
		klaviyoCompanyId: n.klaviyoCompanyId,
		addingToCartLabel: n.addingToCartLabel,
		quantityLabel: n.quantityLabel,
		cartCanCount: j.cartCanCount,
		bundleTiers: j.tiers,
		bundleEligible: j.eligible,
		showPerUnit: n.showPerUnit,
		subPct: N,
		okendoStoreId: n.okendoStoreId
	};
	return /* @__PURE__ */ Z("div", {
		class: "ps-shell",
		children: [
			/* @__PURE__ */ Z(Yn, {
				products: t,
				selectedHandle: a,
				onSelect: o,
				nav: n.carouselNav
			}),
			/* @__PURE__ */ Z("div", {
				class: "visually-hidden",
				"aria-live": "polite",
				"aria-atomic": "true",
				children: v
			}),
			/* @__PURE__ */ Z("div", {
				class: "ps-buyzone",
				"data-ps-buyzone": !0,
				"data-switching-product": l ? "true" : "false",
				children: /* @__PURE__ */ Z("div", {
					class: "ps-buyzone__content",
					"data-switching-product": l ? "true" : "false",
					children: [
						P || F ? /* @__PURE__ */ Z("section", {
							class: "ps-reviews-blurb-text",
							"aria-label": "Reviews and blurb text",
							children: [/* @__PURE__ */ Z("div", {
								class: "ps-reviews-blurb-text__status",
								children: [P ? /* @__PURE__ */ Z(Mt, {
									block: P,
									shared: R
								}) : null, /* @__PURE__ */ Z(Zn, {
									inventoryQuantity: x.inventoryQuantity,
									inventoryManaged: x.inventoryManaged,
									threshold: n.lowStockThreshold,
									label: n.lowStockLabel
								})]
							}), F ? /* @__PURE__ */ Z(Mt, {
								block: F,
								shared: R
							}) : null]
						}) : null,
						I.map((e) => /* @__PURE__ */ Z(Mt, {
							block: e,
							shared: R
						}, e.id)),
						/* @__PURE__ */ Z("div", {
							class: "ps-buyzone__controls",
							children: L.map((e) => /* @__PURE__ */ Z(Mt, {
								block: e,
								shared: R
							}, e.id))
						})
					]
				})
			})
		]
	});
}
//#endregion
//#region src/product-switcher/index.tsx
function zr(e) {
	let t = e.querySelector("script[data-ps-products]");
	if (!t) return [];
	try {
		return JSON.parse(t.textContent || "[]");
	} catch (e) {
		return console.warn("[product-switcher] failed to parse products JSON", e), [];
	}
}
function Br(e) {
	let t = e.querySelector("[data-ps-buyzone]"), n = t ? Array.from(t.children) : Array.from(e.children), r = [], i = 0;
	function a(e) {
		let t = e.dataset.type, n = e.dataset.id;
		if (!t || !n) return;
		let i = {};
		try {
			i = JSON.parse(e.textContent || "{}");
		} catch (e) {
			console.warn("[product-switcher] failed to parse block settings", t, e);
		}
		r.push({
			id: n,
			type: t,
			settings: i
		});
	}
	function o(e) {
		if (!(e instanceof HTMLScriptElement) || !e.matches("script[data-ps-block]")) {
			e instanceof HTMLElement && e.matches("[data-ps-block-output]") && e.querySelectorAll("script[data-ps-block]").forEach(a), e instanceof HTMLElement && !e.matches("[data-ps-block-output]") && (r.push({
				id: `app-${i}`,
				type: "@app",
				settings: { nodes: [e] }
			}), i += 1);
			return;
		}
		a(e);
	}
	return n.forEach(o), r;
}
function Vr(e) {
	let t = e.querySelector("script[data-ps-tiers]");
	if (!t) return [];
	try {
		return JSON.parse(t.textContent || "[]").map((e) => ({
			minQty: Number(e.minQty) || 0,
			pct: Number(e.pct) || 0
		})).filter((e) => e.minQty > 0);
	} catch (e) {
		return console.warn("[product-switcher] failed to parse tiers JSON", e), [];
	}
}
function Hr(e, t) {
	return {
		initialHandle: e.dataset.initialHandle || "",
		carouselNav: {
			showArrows: e.dataset.showArrows === "true",
			showDots: e.dataset.showDots === "true",
			previousLabel: e.dataset.previousLabel || "Previous slide",
			nextLabel: e.dataset.nextLabel || "Next slide"
		},
		recolorHeader: e.dataset.recolorHeader === "true",
		addToCartLabel: e.dataset.addToCartLabel || "Add to cart",
		addingToCartLabel: e.dataset.addingToCartLabel || "Adding...",
		quantityLabel: e.dataset.quantityLabel || "Quantity",
		inStockLabel: e.dataset.inStockLabel || "In stock",
		outOfStockLabel: e.dataset.outOfStockLabel || "Out of stock",
		lowStockLabel: e.dataset.lowStockLabel || "Low stock",
		lowStockThreshold: Number(e.dataset.lowStockThreshold) || 0,
		okendoStoreId: e.dataset.okendoStoreId || "",
		klaviyoCompanyId: e.dataset.klaviyoCompanyId || "WNF3cp",
		subscriptionDiscountPct: Number(e.dataset.subscriptionDiscountPct) || 0,
		bundleEnabled: e.dataset.bundleEnabled === "true",
		bundleTiers: Vr(e),
		showPerUnit: e.dataset.showPerUnit !== "false",
		canProductType: e.dataset.canProductType || "Electrolyte mix",
		shopName: e.dataset.shopName || "",
		updateSeo: e.dataset.updateSeo === "true",
		blocks: t
	};
}
function Ur(e) {
	if (e.dataset.psHydrated === "true") return;
	let t = zr(e), n = Hr(e, Br(e));
	if (!t.length) return;
	let r = e.querySelector(".ps-shell");
	r && r.remove(), e.dataset.psHydrated = "true", V(/* @__PURE__ */ Z(Rr, {
		root: e,
		products: t,
		config: n
	}), e);
}
function Wr() {
	document.querySelectorAll("[data-product-switcher]").forEach(Ur);
}
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", Wr) : Wr();
//#endregion
